/* eslint-disable */

import Phaser from 'phaser';
import { store } from "../stores/mainStore";
import { integration } from '../integration';
import { comm } from '../comm';
import { intToString } from '../tools/intToString';
import {history} from '../history';
import { i18n } from '../i18n';

var m;
export class UI{

	constructor(mgr){
		m = mgr;
		this.goalArrow = null;
		this.goalArrowX = m.config.width/2 - ((480 * 0.30) * m.scaleFactor);
		this.goalArrowY = m.config.height * 0.18;
		this.resultsProfilePicTargetSize = 0.75 * 102 * 1.65 * m.scaleFactor;

		if(window.location.search){
			let qs = new Map(decodeURI(window.location.search).slice(1).split('&').map(p => p.split(/=(.+)/)));
			//optional app store link can be passed in for one hand gamne:
			if(qs.get('storeLink')) {
				m.storeLink = qs.get('storeLink');
				console.log("found storeLink sent in URL: "+m.storeLink);
			}
		}
		
	}
	// dodFontFamily = 'Verdana, "Times New Roman", Tahoma, serif';
	dodFontFamily = 'Jost';// 'Oswald';
	challenge = null;
	challengeCopy = null;
	topImage = null;
	scoreDelay = 750;
	portraitBotName = 'portrait_bot0';
	portraitBotNum = 0;
	myPortraitName = 'myPic_0';
	myPortraitNum = 0;

	printNumber(num) {
		if (store.integration === 'greentube' && num >= 100 * 1000)
			return(intToString(num));
		else
			return(num.toLocaleString());
	}

	unknownOpponent = true;
	matchMe = false;

	rematch() {
		store.isImmediateRematch = true;
		store.setSpinner(true);
		store.createMatch(store.getRandomBotId())
		.then(response => {
			history.push(`/game/${response.Match.Id}/play`);
		})
	}
	resignMatch(id) {
		store.matchIdToResign = store.activeMatch.matchId;
		store.modal = 'resign';
	}
	skipTutorial(id) {
		store.modal = 'skipTutorial';
	}

	showMatchOpponentBanner() {
		if((store.oneTurnGame && !store.introDiceShown) || (store.tutorialMode && store.activeMatch.matchId === 'intro')) {
			m.diceHand.introDiceIntoCup();
			store.introDiceShown = true;
		} else
			m.ui.continueShowMatchOpponentBanner();
	}
	continueShowMatchOpponentBanner() {
		//DEBUG TOUCH
		// m.cup.setWaitForHandPointer(10000);

		m.scene.load.reset();

		if(store.activeMatch.playerCount < 2) {
			m.ui.unknownOpponent = true;
			m.ui.matchMe = true;// false;
		} else {
			m.ui.unknownOpponent = false;
			if(store.activeMatch.type === 'ra')
				m.ui.matchMe = true;
			else
				m.ui.matchMe = false;
		}

		if(m.ui.unknownOpponent) {
			m.ui.portraitBotName = 'portrait_unknown';
		}

		if(store.activeMatch.opponent.image && store.activeMatch.opponent.image !== "") {
			m.scene.load.setCORS('anonymous');
			var imageUrl = store.activeMatch.opponent.image;
			var fixup = imageUrl.replace("http:", "https:");
			m.ui.portraitBotNum++;
			let keyName = fixup.substring(0, 80);
			m.ui.portraitBotName = 'oppPic_'+m.ui.portraitBotNum;
			 m.scene.load.image(m.ui.portraitBotName, fixup, true);
			 console.log("reloading bot image url: "+ fixup + ' into key '+m.ui.portraitBotName);
		} else {
			// m.scene.load.image(m.ui.portraitBotName, m.assetURL+'/portrait_glenn.jpg', true);
			m.ui.portraitBotNum++;
			m.ui.portraitBotName = 'oppPic_'+m.ui.portraitBotNum;
			m.scene.load.image(m.ui.portraitBotName, m.assetURL+'/profile/profile_default.jpg', true);
			console.log("reloading bot image ", m.assetURL+'/profile/profile_default.jpg');
		}

		if(store.tutorialMode) {//} && store.activeMatch.matchId === 'intro') {
			m.clearMessages();
			m.diceHand.unlockAllDice();
			m.diceHand.clearDiceOffScreen();

			// m.ui.clearMatchOpponentBanner();
			// return;
		}

		if(!store.oneTurnGame) {
			if((store.tutorialMode && store.activeMatch.matchId === 'intro')  || /* store.activeMatch.handNumber < store.activeMatch.opponent.currentRound ||*/
				store.activeMatch.viewOnlyMode || store.activeMatch.handNumber > 1 || !(store.activeMatch.currentHand.rollsRemaining === 3)) {
					m.scene.load.once('complete', function (file) {
						m.ui.clearMatchOpponentBanner();
					});
				m.scene.load.start();
				return;
			}
		} else {
			m.clearMessages();
		}

		if(!store.oneTurnGame) {
		m.gameHudBackCover.setAlpha(0);
		m.gameHudLogoCover.setAlpha(0);
		}

		// m.clearMessages();
		// m.diceHand.unlockAllDice();
		// m.diceHand.clearDiceOffScreen();

		if(store.oneTurnGame) {
			this.topImage = m.scene.add.image(m.config.width/2, m.handBannerPosition+82*m.scaleFactor, 'turn_indicator_1_turn');
			this.topImage.setScale(m.oldAssetScaleFactor * 1 * 1.3);
			m.scoreCardElements.push(this.topImage);
		} else
			if(store.tutorialMode) {
				integration.postAnalyticsEvent(`tutorial_loaded`);//, `tutorial_ftue`);
				this.topImage = m.scene.add.image(m.config.width/2, m.handBannerPosition+82*m.scaleFactor, 'language', 'practice_game.png');
				this.topImage.setScale(m.oldAssetScaleFactor * 1 * 1.3);
				m.scoreCardElements.push(this.topImage);
			}  else {
				let turn = (store.activeMatch.handNumber > 6 ? 3 : store.activeMatch.handNumber > 3 ? 2 : 1);
				this.topImage = m.scene.add.image(m.config.width/2, m.ui.matchMe ? m.handBannerPosition + 90*m.scaleFactor : 160*m.scaleFactor, 'language', 'turn_indicator_'+turn+'.png');
				this.topImage.setScale(m.oldAssetScaleFactor * 1 * 1.3);
				m.scoreCardElements.push(this.topImage);
			}

		// if(store.tutorialMode)
		//  {
		// 	this.avaPanel = this.createAvaPanel(m.config.width/2, 852*0.64, "I'll be your opponent\nwhile you practice!", false, 'tutorial_1');
		// }

		if(this.challenge != null)
			this.challenge.destroy();

		if(true){//!store.tutorialMode) {
			this.challenge = m.scene.add.sprite(m.config.width/2, m.adjustY(852) * 0.65, 'msg_challenge');
			this.challenge.setScale( (0.9 * m.ui.matchMe ? 0.9 : 1.1) * 0.5 *m.scaleFactor);

			if(this.challengeCopy != null)
				this.challengeCopy.destroy();
			this.challengeCopy = m.scene.add.sprite(m.config.width/2, m.adjustY(852) * 0.65, 'msg_challenge');
			this.challengeCopy.setScale( 1.1 * 0.5*m.scaleFactor);
			this.challengeCopy.setDepth(6);
			this.challengeCopy.setAlpha(0.0);

			var totalMatches = store.user.matchCount + m.matchesThisSession;
			// console.log("TOTAL MATCHES " + totalMatches);
			// if(totalMatches < 4)
			if(m.ui.matchMe) {
				this.challenge.setFrame(1);
			} else {
				this.challenge.setAlpha(0);
			}
			m.scoreCardElements.push(this.challenge);
		}

		let targetSize = 0.7125 * 222*m.scaleFactor;
		// let picOffset =  0.225;
		let oldDelta = m.adjustX(240) - (m.adjustX(480)*0.225);
		// oldDelta *= m.scaleFactor;

		m.myMatchPic = m.ui.makeProfilePic(m.config.width/2 - oldDelta, m.adjustY(852) * 0.42, targetSize, m.ui.myPortraitName);
		m.scoreCardElements.push(m.myMatchPic);
		m.myLevelStar = m.ui.addLevelStar(m.myMatchPic, targetSize, store.user.level);

		var name = "  "+m.getUsername()+"  ";
		var nameOffset =  /*m.landscape ? */targetSize*0.55;// : -myRing.height*0.45;
		m.myMatchName = m.scene.add.text(m.myMatchPic.x, m.myMatchPic.y+nameOffset, name,
			{ fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#9f5305', strokeThickness: 3 });
		m.myMatchName.setOrigin(0.5,0.5);
		m.myMatchName.setDepth(6);
		m.scoreCardElements.push(m.myMatchName);
		let plateHeight = (m.myMatchName.height+2*m.scaleFactor);
		let ret = m.ui.createNameplate(m.myMatchName.x-m.myMatchName.displayWidth/2, m.myMatchName.y-(plateHeight/2), m.myMatchName.displayWidth, plateHeight, 10, 0xff9226, 1.0, 0x9f5205, 5);
		m.ui.myMatchPlate = ret[0];
		m.ui.myMatchPlateShadow = ret[1];
		var vs = m.scene.add.sprite(m.config.width/2, m.myMatchPic.y, 'language', 'msg_vs.png');
		vs.setScale(m.oldAssetScaleFactor * 0.6);
		m.scoreCardElements.push(vs);

		m.matchBlur = m.scene.add.sprite(m.config.width/2+oldDelta, m.myMatchPic.y, 'portrait_blur');
		m.matchBlur.setScale((targetSize/m.matchBlur.width));
		var shape2 = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false}).fillCircleShape(new Phaser.Geom.Circle( m.matchBlur.x, m.matchBlur.y, 76*m.scaleFactor ));
		m.matchBlur.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape2);
		m.scoreCardElements.push(m.matchBlur);

		m.opponentMatchRing = m.scene.add.sprite(m.matchBlur.x, m.matchBlur.y, 'common', 'portrait_ring.png');
		m.opponentMatchRing.setScale((targetSize/m.opponentMatchRing.width));
		m.scoreCardElements.push(m.opponentMatchRing);
		// m.opponentMatchRing.setDepth(6);

		m.opponentMatchName = m.scene.add.text(m.matchBlur.x, m.myMatchName.y, '  ???  ',
			{ fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#9f5305', strokeThickness: 3 });
		m.opponentMatchName.setOrigin(0.5,0.5);
		m.opponentMatchName.setDepth(6);
		m.scoreCardElements.push(m.opponentMatchName);
		let ret2 = m.ui.createNameplate(m.opponentMatchName.x-m.opponentMatchName.displayWidth/2, m.opponentMatchName.y-(plateHeight/2), m.opponentMatchName.displayWidth, plateHeight, 10, 0xff9226, 1.0, 0x9f5205, 5);
		m.ui.hisMatchPlate = ret2[0];
		m.ui.hisMatchPlateShadow = ret2[1];
		// m.scene.load.on('filecomplete', this.fileDone, this);
		m.scene.load.once('complete', function (file) {
			console.log('REload complete ');

			// if(!store.tutorialMode)

			if(store.oneTurnGame || m.ui.matchMe) { // && !m.ui.unknownOpponent) {
				m.playAudio("OpponentMatchSequence");
				m.matchBlur.on('animationcomplete', m.ui.animComplete, m.ui);
				m.matchBlur.anims.play('portraitBlur', true);
			} else {
				m.ui.showMatchOpponentImage();
			}

			// if(store.tutorialMode)
			// 	m.ui.showMatchOpponentImage();

			// if(file == 'portrait_bot') {
			// 	m.matchBlur.anims.stop();
			// 	m.matchBlur.on('animationcomplete', m.ui.animComplete, m.ui);
			// 	// m.scene.sound.play("prizeWheel");
			// 	m.matchBlur.anims.play('portraitBlur', true);
			// }
		});

		// m.matchBlur.anims.play('prePortraitBlur', true);
		m.scene.load.start();

	}
	myMatchPlate=null;
	myMatchPlateShadow=null;
	hisMatchPlate=null;
	hisMatchPlateShadow=null
	fileDone(file) {
		console.log('file '+file + ' reload complete **************************');
		// if(file == 'portrait_bot') {
		// 	m.matchBlur.anims.stop();
		// 	m.matchBlur.on('animationcomplete', m.ui.animComplete, m.ui);
		// 	// m.scene.sound.play("prizeWheel");
		// 	// m.matchBlur.anims.play('portraitBlur', true);
		// }
	}
	makeProfilePic(x, y, targetSize, image) {
		var container = m.scene.add.container(x, y);
		var me = m.scene.add.sprite(0, 0, image);
		me.setScale(targetSize/me.width);
		var shape = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false}).fillCircleShape(new Phaser.Geom.Circle( x, y, targetSize/2.08 ));
		// shape.setDepth(5);
		container.shape = shape;
		container.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);
		me.setDepth(5);
		container.add(me);
		m.scoreCardElements.push(me);
		var myRing = m.scene.add.sprite(me.x, me.y, 'common', 'portrait_ring.png');
		myRing.setScale((targetSize/myRing.width));
		container.add(myRing);
		m.scoreCardElements.push(myRing);
		myRing.setDepth(5);

		m.scoreCardElements.push(container);
		container.setDepth(5);
		return(container);
	}
	addLevelStar(profilePic, targetSize, level) {
		// let targetSize = profilePic.width*profilePic.scaleX;
		var container = m.scene.add.container(profilePic.x, profilePic.y);

		var adjustScale = (targetSize / (158.175 * m.scaleFactor));
		var adjust = 1.0;
		if(adjustScale < 0.65) {
			adjustScale = 0.65;
			adjust = 1.6;
		}

		let star = m.scene.add.image(targetSize*(0.4*adjust), targetSize*(0.3), 'common', 'levelUp_star.png'); //(myRing.width/2*myRing.scaleX), (myRing.height/2*myRing.scaleY)
		star.setOrigin(0.5,0.5);
		star.setScale(0.75 * m.scaleFactor);
		star.setDepth(6);
		container.add(star);
		m.scoreCardElements.push(star);

		let levelText = m.scene.add.text(star.x, star.y, level, { fontFamily: m.ui.dodFontFamily,  fontSize: '64px', fill: '#6a2c00',
										shadow: { offsetX: 2, offsetY: 2, color: '#ffe474', blur: 0, stroke: false, fill: true }  });

		levelText.setOrigin(0.5,0.5);
		levelText.setDepth(6);
		container.add(levelText);
		m.scoreCardElements.push(levelText);

		container.setScale(0.85 * adjustScale);

		m.scoreCardElements.push(container);
		container.setDepth(6);

		if(store.oneTurnGame)
			container.setAlpha(0);

		return(container);
	}
	killGoalArrow() {
		if(this.goalArrow != null)
			this.goalArrow.destroy();
		if(this.goalArrowTween != null)
			this.goalArrowTween.stop();
		if(this.goalArrowTween2 != null)
			this.goalArrowTween2.stop();
		this.goalArrowTween = null;
		this.goalArrowTween2 = null;
	}
	animateGoalArrow() {
		if(this.goalArrowTween != null)
			this.goalArrowTween.stop();
		if(this.goalArrowTween2 != null)
			this.goalArrowTween2.stop();
		this.goalArrowTween = m.scene.tweens.add({
			targets     : [ this.goalArrow ],
			x: ( m.handBanner.x - 182 * m.scaleFactor ),
			y: ( this.goalArrow.y),
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			// yoyo:	true,
			// hold: 	150,
			duration    : 800, repeat      : 0,
			callbackScope   : this.goalArrowTween,
				completeDelay: 0,
				onComplete: (tween, target) => {
					this.goalArrowTween2 = m.scene.tweens.add({
						targets     : [ this.goalArrow ],
						x: this.goalArrowX,
						y: this.goalArrowY,
						//   ease        : 'Expo.easeIn',
						ease		  : 'Linear',
						// yoyo:	true,
						// hold: 	150,
						duration    : 280, repeat      : 0,
						callbackScope   : this.goalArrowTween,
							completeDelay: 0,
							onComplete: (tween, target) => {
								this.animateGoalArrow();
							},
							onCompleteScope: this.goalArrowTween2,
						});
							},
				onCompleteScope: this.goalArrowTween,
			});
	}

	animComplete(animation, frame) {
		if(animation.key === 'handSpin') {
			// console.log("HANDSPIN ANIM STOPPED");
			var handName = store.activeMatch.goals[store.activeMatch.handNumber-1];
			// if(!handName || handName == null || handName == undefined && (typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
			// 	handName = store.activeMatch.currentHand.bestHandTargetString;
			if(!store.oneTurnGame && store.activeMatch.handNumber >= store.activeMatch.roundCount)
				handName = "five-of-a-kind";	//jackpot graphic in this position in hand spinner sprite sheet
			frame = m.handBannerHandNames.indexOf(handName);
			if(frame <= 0)
				frame = 0;
			m.handBanner.setFrame(frame);
			var oldY = m.handBanner.y;
			m.handBanner.y += m.handBanner.height;

			m.scene.tweens.add({
				targets     : [ m.handBanner ],
				y: oldY,
				//   ease        : 'Expo.easeIn',
				ease		  : 'Expo.easeOut',
				duration    : 500,
				repeat      : 0
			});

			var offset =  0;
			this.goalArrow = m.scene.add.sprite(this.goalArrowX, oldY+offset, 'language', 'goal_arrow.png');
			this.goalArrowY = this.goalArrow.y;
			this.goalArrow.setScale(m.oldAssetScaleFactor * (m.landscape ? 0.9 : 1.0));
			this.goalArrow.setDepth(6);
			this.animateGoalArrow();

			// if(!store.tutorialMode)
				m.scoreCardElements.push(this.goalArrow);

			return;
		}
		if(animation.key === 'portraitBlur') {
			if(!store.tutorialMode)
				this.showMatchOpponentImage();
		}
		if(animation.key === 'poof') {
			// animation.parent.destroy();
		}
	}

	showMatchOpponentImage = () => {
		// console.log("portraitBlur ANIM STOPPED");
		var targetSize = (0.75*0.95) * 232*m.scaleFactor;
		m.opponentMatchPic = m.ui.makeProfilePic(m.matchBlur.x, m.matchBlur.y, targetSize, m.ui.portraitBotName);
		if(!store.activeMatch.opponent.isBot && store.activeMatch.opponent.level)
			m.opponentLevelStar = m.ui.addLevelStar(m.opponentMatchPic, targetSize, store.activeMatch.opponent.level);

		m.scoreCardElements.push(m.opponentMatchPic);
		// m.opponentMatchRing.destroy();

		m.opponentMatchName.text = store.activeMatch.opponent.name ? ("  "+store.activeMatch.opponent.name+"  ") : "  Opponent  ";// store.activeMatch.opponent.name;
		let plateHeight = (m.opponentMatchName.height+2);
		let ret2 = m.ui.createNameplate(m.opponentMatchName.x-m.opponentMatchName.displayWidth/2, m.opponentMatchName.y-(plateHeight/2), m.opponentMatchName.displayWidth, plateHeight, 10, 0xff9226, 1.0, 0x9f5205, 5);
		if(m.ui.hisMatchPlate != null) {
			m.ui.hisMatchPlate.destroy();
			m.ui.hisMatchPlateShadow.destroy();
		}
		m.ui.hisMatchPlate = ret2[0];
		m.ui.hisMatchPlateShadow = ret2[1];

		if(m.matchBlur)
			m.matchBlur.destroy();

		if(!m.ui.matchMe) {
			let tuttle = store.tutorialMode ? 0 : 1;
			let moveTween9 = m.scene.tweens.add({
				targets     : [ m.ui.topImage ],
				y			: m.ui.topImage.y-(30*tuttle),
				// ease		  : 'Expo.easeOut',
				ease		  : 'Linear',
				duration    : 300,
				delay		: 500,
				repeat      : 0,
				onComplete: (tween, target) => {
					m.playAudio('transitionsMovement');
					let moveTween = m.scene.tweens.add({
						targets     : [ m.ui.topImage ],
						y			: m.ui.topImage.y+(125*m.scaleFactor*tuttle),
						ease		: 'Linear',
						duration    : 120,
						repeat      : 0,
						onComplete: (tween, target) => {
							let moveTween2 = m.scene.tweens.add({
								targets     : [ m.ui.topImage ],
								y			: store.tutorialMode ? (m.ui.topImage.y-((store.tutorialMode ? 75*m.scaleFactor : 50*m.scaleFactor)*tuttle)) : m.handBannerPosition + 90*m.scaleFactor,
								ease		: 'Linear',
								duration    : 150,
								repeat      : 0,
								onComplete: (tween, target) => {
									m.myLevelStar.destroy();
									if(m.opponentLevelStar && m.opponentLevelStar != null)
										m.opponentLevelStar.destroy();
									m.myMatchName.setAlpha(0);
									m.ui.myMatchPlate.setAlpha(0);
									m.ui.myMatchPlateShadow.setAlpha(0);
									m.opponentMatchName.setAlpha(0);
									m.ui.hisMatchPlate.setAlpha(0);
									m.ui.hisMatchPlateShadow.setAlpha(0);
									let myX = m.myMatchPic.x;
									let hisX = m.opponentMatchPic.x;

									let moveTween3 = m.scene.tweens.add({
										targets     : [ m.myMatchName, m.myMatchPic ],
										x			: m.myMatchPic.x-45*m.scaleFactor,
										// ease		  : 'Expo.easeOut',
										ease		  : 'Linear',
										duration    : 350,
										repeat      : 0,
										onComplete: (tween, target) => {
											let moveTween4 = m.scene.tweens.add({
												targets     : [ m.myMatchPic, m.myMatchName ],
												x			: myX+60*m.scaleFactor,
												ease		: 'Linear',
												duration    : 100,
												repeat      : 0,
												onComplete: (tween, target) => {
													var lilStars = m.scene.add.sprite(myX+135*m.scaleFactor, m.myMatchPic.y, 'poof');
													lilStars.setScale(2.65*m.scaleFactor);
													lilStars.setDepth(6);
													m.scoreCardElements.push(lilStars);
													lilStars.on('animationcomplete', m.ui.animComplete, this);
													m.playAudio("bumper");
													lilStars.anims.play('poof', true);

													let moveTween8 = m.scene.tweens.add({
														targets     : [ m.myMatchPic, m.myMatchName ],
														x			: myX,
														ease		: 'Bounce',
														duration    : 300,
														repeat      : 0,
														onComplete: (tween, target) => {
															m.ui.updateMaskPositions();
															// m.ui.continueShowMatchOpponentImage();
															m.myLevelStar = m.ui.addLevelStar(m.myMatchPic, targetSize, store.user.level);
															if(!store.activeMatch.opponent.isBot && store.activeMatch.opponent.level)
																m.opponentLevelStar = m.ui.addLevelStar(m.opponentMatchPic, targetSize, store.activeMatch.opponent.level);
															m.myMatchName.setAlpha(1);
															m.ui.myMatchPlate.setAlpha(1);
															m.ui.myMatchPlateShadow.setAlpha(1);
															m.opponentMatchName.setAlpha(1);
															m.ui.hisMatchPlate.setAlpha(1);
															m.ui.hisMatchPlateShadow.setAlpha(1);
														}
													});
													m.scoreCardTweens.push(moveTween8);
												}
											});
											m.scoreCardTweens.push(moveTween4);
										}
									});
									m.scoreCardTweens.push(moveTween3);

									let moveTween5 = m.scene.tweens.add({
										targets     : [ m.opponentMatchName, m.opponentMatchPic, m.opponentMatchRing ],
										x			: m.opponentMatchPic.x+45*m.scaleFactor,
										// ease		  : 'Expo.easeOut',
										ease		  : 'Linear',
										duration    : 350,
										repeat      : 0,
										onUpdate: (tween, target) => {
											m.ui.updateMaskPositions();
										},
										onComplete: (tween, target) => {
											let moveTween6 = m.scene.tweens.add({
												targets     : [ m.opponentMatchPic, m.opponentMatchName, m.opponentMatchRing ],
												x			: hisX-60*m.scaleFactor,
												ease		: 'Linear',
												duration    : 100,
												repeat      : 0,
												onUpdate: (tween, target) => {
													m.ui.updateMaskPositions();
												},
												onComplete: (tween, target) => {
													let moveTween7 = m.scene.tweens.add({
														targets     : [ m.opponentMatchPic, m.opponentMatchName, m.opponentMatchRing ],
														x			: hisX,
														ease		: 'Bounce',
														duration    : 300,
														repeat      : 0,
														onUpdate: (tween, target) => {
															m.ui.updateMaskPositions();
														},
														onComplete: (tween, target) => {
														}
													});
													m.scoreCardTweens.push(moveTween7);
												}
											});
											m.scoreCardTweens.push(moveTween6);
										}
									});
									m.scoreCardTweens.push(moveTween5);
								}
							});
							m.scoreCardTweens.push(moveTween2);
						}
					});
					m.scoreCardTweens.push(moveTween);
				}
			});
			m.scoreCardTweens.push(moveTween9);

			gameSetTimeout(m.ui.continueShowMatchOpponentImage, 1750);
		} else
			m.ui.continueShowMatchOpponentImage();
	}
	updateMaskPositions() {
		var targetSize = 0.7125 * 222*m.scaleFactor;
		// console.log("tweening mofo");
		let shape = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false}).fillCircleShape(new Phaser.Geom.Circle( m.myMatchPic.x, m.myMatchPic.y, targetSize/2.08 ));
		m.myMatchPic.shape = shape;
		m.myMatchPic.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);
		let shape2 = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false}).fillCircleShape(new Phaser.Geom.Circle( m.opponentMatchPic.x, m.opponentMatchPic.y, targetSize/2.08 ));
		m.opponentMatchPic.shape = shape2;
		m.opponentMatchPic.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape2);
	}
	continueShowMatchOpponentImage() {
		if(true){//!store.tutorialMode) {
			m.ui.challenge.setAlpha(1.0);
			m.ui.challenge.setFrame(3);
			m.ui.challenge.setScale((1.25 * 1.1) * 0.5*m.scaleFactor);
			// m.playAudio('twinkle');

			let floatingStars = m.scene.add.sprite(m.ui.challengeCopy.x-30*m.scaleFactor, m.ui.challengeCopy.y-60*m.scaleFactor, 'floatingStars001');
			floatingStars.setScale(0.9*m.scaleFactor);
			floatingStars.setDepth(5);
			floatingStars.anims.play('floatingStars');
			m.scoreCardElements.push(floatingStars);

			m.ui.challengeCopy.setFrame(3);
			m.ui.challengeCopy.setAlpha(1.0);
			let evapTween = m.scene.tweens.add({
				targets     : [ m.ui.challengeCopy ],
				scaleX		: 3,
				scaleY		: 3,
				alpha		: 0.0,
				ease		: 'Linear',
				duration    : 700,
				repeat      : 0
				});
			m.scoreCardTweens.push(evapTween);

			// let needToAcceptChallenge = store.activeMatch.type === 'ch' && store.activeMatch.state === 'pe';
			let needToAcceptChallenge = store.activeMatch.needToAcceptChallenge && store.activeMatch.needToAcceptChallenge === true;

			if(needToAcceptChallenge) {
				let accept = m.ui.createButton('btn_accept.png', m.config.width/2, m.adjustY(852)*0.775, m.adjustX(480)*0.675, m.ui.defaultButtonHeight*1.5, "Accept", function (pointer) {
					console.log("accept match continue");
					integration.postAnalyticsEvent(`challenge_accept_button`);

					m.ui.clearMatchOpponentBanner();
				});
				m.ui.makePulsate(accept);
				m.scoreCardElements.push(accept);

				let decline = m.ui.createButton('btn_decline.png', m.config.width/2, m.adjustY(852)*0.9, m.adjustX(480)/2, m.ui.defaultButtonHeight*1.25, "Decline", function (pointer) {
					console.log("decline match continue");
					integration.postAnalyticsEvent(`challenge_decline_button`);
					comm.AbandonMatch(store.activeMatch.matchId)
					.then(() => {
						history.push(`/`);
					})
					.catch(() => {
						history.push(`/`);
					});
				});
				m.scoreCardElements.push(decline);
			} else
				gameSetTimeout(m.ui.clearMatchOpponentBanner, m.ui.matchMe ? 1500 : 2750);

		} else {
			let tutCont = m.ui.createButton('btn_continue_green.png', m.config.width/2, m.adjustY(852)*0.815, m.adjustX(480)/2, m.ui.defaultButtonHeight*1.5, "Continue", function (pointer) {
				console.log("tutorial match continue");
				// integration.postAnalyticsEvent('press_continue', 'tutorial');
				m.ui.clearMatchOpponentBanner();
			});
			m.ui.makePulsate(tutCont);
			m.scoreCardElements.push(tutCont);
		}
	}

	clearAvaPanel() {
		if(m.avaPanel != null)
			m.avaPanel.destroy();
		if(m.avaFace != null)
			m.avaFace.destroy();
	}
	tutorialStraightText = "You got a Straight in 1 roll!\nYou have 2 more rolls to\nimprove to a\nhigher-ranking Straight";
	createAvaPanel(x, y, text, showFace, image) {
		m.ui.clearAvaPanel();
		m.avaPanel = m.scene.add.container(x-m.config.width, y);
		m.avaPanel.setDepth(5);

		let panel = m.scene.add.sprite(0,0, 'tutorial', image+'.png');// 'tutorialMatchPanel');
		// panel.setScale(y == (m.config.height*0.375) || y == (m.config.height*0.305) ? 0.8 : 0.675);
		panel.setScale(0.675*m.scaleFactor);
		m.avaPanel.add(panel);

		// var fontSize = text === 'Great job!' || text === 'You got it!' ? '36px' : showFace ? '27px' : '30px';
		// if(text === m.ui.tutorialStraightText || y === m.config.height*0.275)
		// 	fontSize = '24px';
		// let textY = text === m.ui.tutorialStraightText ? -2 : showFace ? -15 : -2.5;
		// let msg = m.scene.add.text(0, textY, text, { fontFamily: m.ui.dodFontFamily, fontSize: fontSize, align:'center', fill: '#ffffff', stroke: '#0', strokeThickness: 4 });
		// msg.setOrigin(0.5,0.5);
		// m.avaPanel.add(msg);

		if(showFace) {
			let faceX = x-panel.width/2*0.6;
			var targetSize = 0.75 * 102 * 1.4*m.scaleFactor;
			let yOffset = text === m.ui.tutorialStraightText ? 10 : 0;
			m.avaFace = m.ui.makeProfilePic(faceX,y+yOffset+panel.height/2*0.65, targetSize, 'portrait_Ava');
			m.avaFace.setAlpha(0);
		}

		m.scene.tweens.add({
			targets     : [ m.avaPanel ],
			x: x,
			// y: scoreCardY,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				if(false) {
					m.avaFace.setAlpha(1);
				}
			}
		});
		// m.scoreCardElements.push(container);
		return m.avaPanel;
	}
	avaPanelPos = 0.68;

	makePulsate(obj) {
		let scale = obj.scaleX;
		let tween = m.scene.tweens.add({
			targets     : [ obj ],
			scaleX: scale * 1.15,
			scaleY: scale * 1.15,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 750,
			repeat      : -1,
			yoyo: true
		});
		m.scoreCardTweens.push(tween);
	}

	showRays = () => {
		//TODO: Remove from sprite sheet
		var rays = m.scene.add.sprite(m.config.width/2, m.bannerContainer.y, 'rays');
		rays.setScale(m.oldAssetScaleFactor * 1.1);
		rays.setDepth(3);
		m.scoreCardElements.push(rays);
		var rayTween = m.scene.tweens.add({
			targets     : [ rays ],
			angle		: 360,
			ease		: 'Linear',
			duration    : 5000,
			repeat      : -1
			});
		m.scoreCardTweens.push(rayTween);
		m.playAudio('finalWinning');
	}

	bumperDelay = 200;
	startBumperDelay = () => {
		this.bumperPlaying = true;
		gameSetTimeout(() => {this.bumperPlaying = false}, this.bumperDelay);
		this.bumperDelay = 150;
	}
	collisionStars = (x, y) => {
		if(!this.bumperPlaying) {
			var lilStars = m.scene.add.sprite(x, y, 'poof');
			// lilStars.setScale(lilStars.scaleX*1.3);
			lilStars.setDepth(2);
			m.scoreCardElements.push(lilStars);
			lilStars.on('animationcomplete', this.animComplete, this);

			// m.playHaptic('haptic_heavyImpact');

			m.playAudio("bumper");
			lilStars.anims.play('poof', true);
			this.startBumperDelay();
		}
	}
	userProfilePicLoaded = false;
	previousUserProfilePicLoaded = false;
	loadUserProfilePic = () => {
		if(this.userProfilePicLoaded) {
			// if(store.activeMatch.handNumber === 1) {
				m.ui.showMatchOpponentBanner();
			// } else {
			// 	m.ui.clearMatchOpponentBanner();
			// }
			return;
		}
		m.scene.load.on('complete', function (file) {
			if(m.ui.userProfilePicLoaded)
				return;
			// console.log('USER PIC load complete ');
			m.ui.previousUserProfilePicLoaded = m.ui.userProfilePicLoaded;
			// if(store.user.image && store.user.image != "")
				m.ui.userProfilePicLoaded = true;
			// if(store.activeMatch.handNumber === 1) {
				m.ui.showMatchOpponentBanner();
			// } else {
			// 	m.ui.clearMatchOpponentBanner();
			// }
		});

		if(store.user.image && store.user.image !== "") {
			m.ui.myPortraitNum++;
			m.ui.myPortraitName = 'myPic_'+m.ui.myPortraitNum;
			m.scene.load.setCORS('anonymous');
			var imageUrl = store.user.image;
			 m.scene.load.image(m.ui.myPortraitName, imageUrl, true);
			 console.log("loading player image url: "+ imageUrl);
		} else {
			m.ui.myPortraitNum++;
			m.ui.myPortraitName = 'myPic_'+m.ui.myPortraitNum;
			m.scene.load.image(m.ui.myPortraitName, m.assetURL+'/profile/profile_default.jpg', true);
			store.user.imageUsed = m.assetURL+'/profile/profile_default.jpg';
		}
		m.scene.load.start();
	}

	createGameHud() {
		m.gameHud = m.scene.add.container(m.config.width/2, 0);
		// hud.setOrigin(0.5, 0);
		m.gameHud.setDepth(6);

		let hudBackground = m.scene.add.image(0, 0, 'common', 'hud_theme_vegas_blue.png');
		hudBackground.setScale(m.config.width/hudBackground.width, 960/hudBackground.width);
		hudBackground.setOrigin(0.5, 0);
		m.gameHud.add(hudBackground);
		m.gameHud.hudBackHeight = hudBackground.height * hudBackground.scaleY;

		let logo = m.scene.add.image(31, 3, 'common', 'hud_siu_logo_tiny.png');
		logo.setOrigin(0.5,0);
		logo.setScale(0.762*2);
		m.gameHud.add(logo);

		let heartArea = m.scene.add.image(m.adjustX(146), m.gameHud.hudBackHeight/2-1, 'common', 'hud_empty_bar.png').setInteractive();
		heartArea.setOrigin(0,0.5);
		heartArea.setScale(0.7*2);
		m.gameHud.add(heartArea);
		heartArea.on('pointerup', function (pointer) {
			// if(!m.ui.scorecardIsVisible())
			if(!store.tutorialMode && !store.showProductStore){
				m.playAudio("poopPop");
				console.log(`shakeproduct HeartArea Store Button`);
				m.showProductStore();
			}
		});
		let heart = m.scene.add.image(heartArea.x-7*m.scaleFactor, heartArea.y-3*m.scaleFactor, 'common', 'hud_icon_heart.png');
		heart.setOrigin(0.5,0.5);
		heart.setScale(0.762*2);
		m.gameHud.add(heart);

		m.heartText = m.scene.add.text(heartArea.x+heartArea.width/2*heartArea.scaleX+9*m.scaleFactor, heartArea.y-2*m.scaleFactor, store.user.hearts, { fontFamily: m.ui.dodFontFamily,  fontSize: '48px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
		m.heartText.setOrigin(0.5,0.5);
		m.gameHud.add(m.heartText);

		let plus = m.scene.add.image(heartArea.x+heartArea.width*heartArea.scaleX+1, heartArea.y+heartArea.height*heartArea.scaleY/2-4, 'common', 'hud_btn_plus.png').setInteractive();
		plus.setOrigin(0.5,0.5);
		plus.setScale(0.625*2);
		m.gameHud.add(plus);
		plus.on('pointerup', function (pointer) {
			// if(m.ui.scorecardIsVisible())
			// 	return;
			if(!store.tutorialMode && !store.showProductStore){
				m.playAudio("poopPop");
				console.log(`shakeproduct Plus Store Button`);
				m.showProductStore();
			}
		});

		let levelArea = m.scene.add.image(m.adjustX(-130), heartArea.y, 'common', 'hud_empty_bar.png');
		levelArea.setOrigin(0,0.5);
		levelArea.setScale(0.8*2, 0.7*2);
		m.gameHud.add(levelArea);

		let purple = m.scene.add.image(levelArea.x, levelArea.y, 'common', 'hud_empty_bar_full_purple_segment.png').setInteractive();
		purple.setOrigin(0,0.5);
		purple.setScale(0.1*2, levelArea.scaleY);
		m.gameHud.add(purple);
		m.gameHud.purple = purple;
		m.gameHud.purple.fullWidth = (levelArea.width * levelArea.scaleX);

		// m.gameHud.debug = m.scene.add.text(levelArea.x, levelArea.y, 'debug', { fontFamily: m.ui.dodFontFamily,  fontSize: '22px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
		// m.gameHud.debug.setOrigin(0,0.5);
		// m.gameHud.debug.setDepth(5);
		// m.gameHud.add(m.gameHud.debug);

		let star = m.scene.add.image(levelArea.x-2, levelArea.y-4, 'common', 'hud_icon_star.png').setInteractive();
		star.setOrigin(0.5,0.5);
		star.setScale(0.75*2);
		m.gameHud.add(star);
		m.gameHudLevelText = m.scene.add.text(star.x, star.y, store.user.level, { fontFamily: m.ui.dodFontFamily,  fontSize: '64px', fill: '#6a2c00',
					shadow: { offsetX: 2, offsetY: 2, color: '#ffe474', blur: 0, stroke: false, fill: true } });
		m.gameHudLevelText.setOrigin(0.5,0.5);
		m.gameHud.add(m.gameHudLevelText);

		m.ui.updateProgressBar(false, 0);

		purple.on('pointerup', function (pointer) {
			store.showProfile = true;
		});
		star.on('pointerup', function (pointer) {
			store.showProfile = true;
		});


		if(!store.tutorialMode && !store.activeMatch.viewOnlyMode)
			m.gameHudBackButton = m.scene.add.image(-m.config.width/2+5, 5, 'common', 'hud_resign.png').setInteractive();
		else
			m.gameHudBackButton = m.scene.add.image(-m.config.width/2+5, 5, 'common', 'hud_back.png').setInteractive();
		m.gameHudBackButton.setScale(0.8*2);
		m.gameHudBackButton.setOrigin(0, 0);
		m.gameHud.add(m.gameHudBackButton);
		m.gameHudBackButton.on('pointerdown', function (pointer) {
			// if(m.ui.scorecardIsVisible())
			// 	return;
			this.setTint(0xe0e0e0);
			m.playAudio("poop");
			// this.setFrame(1);
		});
		m.gameHudBackButton.on('pointerup', function (pointer) {
			// if(m.ui.scorecardIsVisible())
			// 	return;
			this.clearTint();
			m.playAudio("pop");

			m.ui.processBackButton();

			// this.destroy();
		});

		if(store.tutorialMode && store.activeMatch.matchId === 'intro')
			m.gameHudBackButton.setAlpha(0);

		//new hud to cover normal hud during intro
		if(!store.isHardRock)
			m.gameHudBackCover = m.scene.add.image(0, 0, 'common', 'hud_theme_vegas_blue.png').setInteractive();
		else
			m.gameHudBackCover = m.scene.add.image(0, 0, 'gameHudBackCoverHR').setInteractive();
		// m.gameHudBackCover.setScale(m.config.width / m.gameHudBackCover.width, 960/m.gameHudBackCover.width);
		m.gameHudBackCover.setScale(m.config.width / m.gameHudBackCover.width, m.config.width / m.gameHudBackCover.width);
		m.gameHudBackCover.setOrigin(0.5, 0);
		m.gameHud.add(m.gameHudBackCover);
		m.gameHudBackCover.setAlpha(0);
		m.gameHudLogoCover = m.scene.add.image(0,0, 'gameHudLogoCover');
		m.gameHudLogoCover.setOrigin(0.5,0);
		m.gameHudLogoCover.setScale(m.config.width/m.gameHudLogoCover.width, 960/m.gameHudLogoCover.width);
		m.gameHud.add(m.gameHudLogoCover);
		m.gameHudLogoCover.setAlpha(0);

		if(store.oneTurnGame || (store.tutorialMode && store.activeMatch.matchId === 'intro')) {
			m.gameHudBackCover.setAlpha(1);
			m.gameHudLogoCover.setAlpha(1);
		}
	}

	processAndroidBackButton() {
		if(m.zoomerContainer != null)
			m.ui.doZoomButtonUp();
		else {
			if(store.modal != '') {
				store.modal = '';
			} else
				m.ui.processBackButton();
		}
	}

	processBackButton() {
		if(store.activeMatch.viewOnlyMode)
			// m.ui.slideOffScorecard(1, true);
			store.getLobbyData().then(() => {
			history.push('/');
			})
		else
		// window.history.back();
		if(store.tutorialMode) {
			m.ui.skipTutorial();
		} else
			m.ui.resignMatch();
		// store.modal = 'scoring';
	}

	previousXpNext = 0;
	previousXpStart = 0;
	updateProgressBar(animate, del) {
		// m.gameHud.debug.text = "xp:"+store.user.xp.toFixed(2)+" xpS:"+store.user.xpStart.toFixed(2)+" xpN:"+store.user.xpNext.toFixed(2);
		let usePrevious = animate === true && del === 1200;//(results delay)
		let xpNext = usePrevious ? this.previousXpNext : store.user.xpNext;
		let xpStart = usePrevious ? this.previousXpStart : store.user.xpStart;
		if(!usePrevious) {
			m.ui.previousXpNext = store.user.xpNext;
			m.ui.previousXpStart = store.user.xpStart;
		}
		let value = animate ? store.user.animateToXp : store.user.xp;
		if(xpStart >= 0 && xpNext > xpStart && value >= xpStart) {
			let xp = value - xpStart;
			var width = (xp / (xpNext - xpStart));
			if(width > 1)
				width = 1;
			width = width * m.gameHud.purple.fullWidth;
			let targetScaleX = width / m.gameHud.purple.width;
			if(animate) {
				m.playAudio("RewardsPopupHearts")
				m.scene.tweens.add({
					targets     : [ m.gameHud.purple ],
					scaleX		: targetScaleX,
					ease		  : 'Linear',
					delay		: del,
					duration    : 1300,
					repeat      : 0,
					completeDelay: 0,
					onComplete: (tween, target) => {
						m.updateLevelInfo();
					}
				});
			} else {
				m.gameHud.purple.setScale(targetScaleX, m.gameHud.purple.scaleY);
				m.updateLevelInfo();
			}
		}
	}

	clearMatchOpponentBanner = () => {
		m.clearMessages();

		if(store.tutorialMode && store.activeMatch.handNumber === 1 && store.activeMatch.currentHand.rollNumber === 0) {
			m.ui.showRoundBanner();
			return; //cup already shown for initial tutorial dice dropping
		}

		gameSetTimeout(m.ui.continueToGameFlow, 500);

	}
	continueToGameFlow() {
		if(store.activeMatch.viewOnlyMode || store.activeMatch.handNumber > 1) {

			if(store.activeMatch.viewOnlyMode && store.activeMatch.handNumber === 9)
				integration.postAnalyticsEvent(`view_postgame`, `economy`);

			if((store.activeMatch.viewOnlyMode || store.activeMatch.handNumber === 9) && store.activeMatch.currentHand.complete)
				m.ui.showScorecard(store.activeMatch.handNumber, true);
			else
				m.ui.showScorecard(store.activeMatch.handNumber-1, true);

			//suppress resume modal over scorecard when returning for your turn at beginning of round or collecting XP
			if(store.activeMatch.state === 'pl') {
				if(store.activeMatch.userState === 'cl')
					return;
				if(store.activeMatch.userState === 'pl')
					if(store.activeMatch.handNumber === 2 || store.activeMatch.handNumber === 4 || store.activeMatch.handNumber === 7)
						return;
			}

			if(!store.activeMatch.viewOnlyMode)
				store.modal = 'resume';

		} else {
			m.ui.showRoundBanner();
		}
	}

	fadeInPinkHeart() {
		if(m.pinkHeart != null) {
			// m.scene.tweens.add({
			// 	targets     : [ m.pinkHeart, m.heartText ],
			// 	alpha		: 1.0,
			// 	ease		  : 'Linear',
			// 	duration    : 200,
			// 	repeat      : 0,
			// 	completeDelay: 0
			// });
		}
		if(m.ui.goalArrow != null) {
			m.scene.tweens.add({
				targets     : [ m.ui.goalArrow ],
				alpha		: 1.0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(m.handBanner != null  && store.activeMatch.matchId !== 'intro') {
			m.scene.tweens.add({
				targets     : [ m.handBanner, m.handBannerBack ],
				alpha		: 1.0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(m.handHelp != null && store.activeMatch.matchId !== 'intro') {
			m.scene.tweens.add({
				targets     : [ m.handHelp ],
				alpha		: 1.0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(store.tutorialMode && store.activeMatch.handNumber > 1)
			if(m.skipTutorial != null) {
				m.scene.tweens.add({
					targets     : [ m.skipTutorial ],
					alpha		: 1.0,
					ease		  : 'Linear',
					duration    : 200,
					repeat      : 0,
					completeDelay: 0
				});
			}
	}
	fadeOutPinkHeart() {
		if(m.pinkHeart != null) {
			// m.scene.tweens.add({
			// 	targets     : [ m.pinkHeart, m.heartText ],
			// 	alpha		: 0,
			// 	ease		  : 'Linear',
			// 	duration    : 200,
			// 	repeat      : 0,
			// 	completeDelay: 0
			// });
		}
		if(m.ui.goalArrow != null) {
			m.scene.tweens.add({
				targets     : [ m.ui.goalArrow ],
				alpha		: 0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(m.handBanner != null) {
			m.scene.tweens.add({
				targets     : [ m.handBanner, m.handBannerBack ],
				alpha		: 0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(m.handHelp != null) {
			m.scene.tweens.add({
				targets     : [ m.handHelp ],
				alpha		: 0,
				ease		  : 'Linear',
				duration    : 200,
				repeat      : 0,
				completeDelay: 0
			});
		}
		if(store.tutorialMode)
		if(m.skipTutorial != null) {
			m.skipTutorial.setAlpha(0);
			// m.scene.tweens.add({
			// 	targets     : [ m.skipTutorial ],
			// 	alpha		: 0,
			// 	ease		  : 'Linear',
			// 	duration    : 200,
			// 	repeat      : 0,
			// 	completeDelay: 0
			// });
		}
	}
	showPinkHeart() {
		if(m.pinkHeart != null)
			return;
		m.pinkHeart = m.scene.add.sprite(m.config.width-(35), (m.handBannerPosition-m.gameHud.hudBackHeight)+3, 'common', 'pinkHeart.png').setInteractive();
		//(if needed to accomodate the new arrow UI from R7:)
		// m.pinkHeart = m.scene.add.sprite(m.config.width-(m.landscape ? 116 : 70), m.handBannerPosition-(m.landscape ? 5 : 50), 'pinkHeart').setInteractive();
		m.pinkHeart.setScale((1.0-0.25/2));
		m.pinkHeart.setDepth(6);

		let xOff = store.integration === 'greentube' ? 15 : 0;
		// m.heartText = m.scene.add.text(m.pinkHeart.x-(m.landscape ? xOff : 0), m.pinkHeart.y - (m.landscape ? 2 : 0), store.user.hearts, { fontFamily: m.ui.dodFontFamily, fontSize: '28px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
		// m.heartText.setOrigin(0.5,0.5);
		// m.heartText.setDepth(6);

		if(true){//store.activeMatch.roundCount < 3) {
			m.pinkHeart.setAlpha(0);
			// m.heartText.setAlpha(0);
			return;
		}

		m.pinkHeart.on('pointerdown', function (pointer) {
			m.pinkHeart.setTint(0xe0e0e0);
			m.playAudio("poop");
			store.modal = 'preheart'
		});
		m.pinkHeart.on('pointerup', function (pointer) {
			m.pinkHeart.clearTint();
			m.playAudio("pop");
			if(store.modal === 'preheart') store.modal = 'heart';
		});
	}

	inGameAfterInterstitial = false;

	showRoundBanner() {
		m.clearMessages();
		m.diceHand.unlockAllDice();
		m.diceHand.clearDiceOffScreen();

		m.ui.inGameAfterInterstitial = false;
		if(!m.showInterstitialVideo())
			m.ui.continueShowRoundBanner();
	}
	continueShowRoundBanner() {
		m.ui.inGameAfterInterstitial = true;
		m.ui.showPinkHeart();

		m.ui.updateProgressBar(false, 0);

		m.handBannerBack = m.scene.add.sprite(m.config.width/2, m.handBannerPosition, 'goalPanel');
		m.handBannerBack.setScale(m.oldAssetScaleFactor);
		m.handBannerBack.setDepth(3);
		m.handBanner = m.scene.add.sprite(m.handBannerBack.x, m.handBannerBack.y, 'goalPanel');
		m.handBanner.setScale(m.oldAssetScaleFactor);

		// var mask = m.scene.make.sprite({ x: m.handBanner.x, y:m.handBanner.y, key: 'goalPanelMask', add: false });
		// mask.setScale(m.config.width/640);
		// m.handBanner.mask = new Phaser.Display.Masks.BitmapMask(m.scene, mask);
		var width = 240*2, height = 50*2;
		var shape = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false}).fillRectShape(new Phaser.Geom.Rectangle(m.handBanner.x-width/2, m.handBanner.y-height/2, width, height));
		m.handBanner.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);

		m.handBanner.setDepth(3);

		function helpDown() {
			this.downOnHelp = true;
			gameSetTimeout(() => {this.downOnHelp = false}, 1000);
			this.y += 5;
			m.playAudio("poop");
			// if(this.displayWidth < 200){
			// 	this.setFrame(1);
			// }
		}
		function helpOut() {
			this.y = this.homeY;
		}
		function helpUp() {

			this.y = this.homeY;
			if(this.displayWidth < 200){
				this.setFrame(0);
			}
			if(this.downOnHelp === true){
				m.playAudio("pop");
				integration.postAnalyticsEvent(`press_help_hand_desc`, 'navigation', store.activeMatch.goals[store.activeMatch.handNumber-1]);
				store.modal = 'hand';
				if(store.tutorialMode && store.tutorialState === 'handInfo'){
					store.tutorialState = '';
					store.tutorialPreventRoll = false;
					store.m.cup.reallyReturnCup(true);
				}
			}
		}

		m.handHelp = m.scene.add.sprite(m.handBannerBack.x + 145*2, m.handBannerBack.y, 'button_help').setInteractive();
		m.handHelp.setScale((m.oldAssetScaleFactor * 0.75));
		m.handHelp.setDepth(3);
		m.handHelp.homeY = m.handHelp.y;
		m.handHelp.on('pointerdown', helpDown);
		m.handHelp.on('pointerup', helpUp);
		m.handHelp.on('pointerout', helpOut);

		if(store.tutorialMode) {
			m.skipTutorial = m.ui.createButton('btn_skip_tutorial.png', m.config.width - 100*2, m.config.height - 40*2, (480*2)*0.35, m.ui.defaultButtonHeight, "Skip Tutorial", function (pointer) {
				console.log("skip tutorial");

				// var promise = Promise.resolve();
				// promise = comm.FinishTutorial(false)
				// .then(() => {
				// 	store.tutorialMode = false;
				// 	store.tutorialState = '';
				// });\
				// store.tutorialMode = false;
				// history.push('/game-type-select');

				integration.postAnalyticsEvent(`press_skip_button`, 'tutorial');

				m.ui.skipTutorial();

			});
			m.skipTutorial.setDepth(3);
			if(store.activeMatch.handNumber === 1)
				m.skipTutorial.setAlpha(0);
		}
		if(store.tutorialMode && store.activeMatch.matchId === 'intro') {
			m.handBannerBack.setAlpha(0);
			m.handBanner.setAlpha(0);
			m.handHelp.setAlpha(0);

			let rollTheDice = m.scene.add.sprite(m.config.width/2, m.config.height*0.425, 'short_tutorial_msg_roll');
			rollTheDice.setDepth(3);
			rollTheDice.setScale(0.75*2);
			m.scoreCardElements.push(rollTheDice);

			// m.cup.setWaitForHandPointer(2000);

			m.cup.reallyFakeReturnCup(false);

			integration.postAnalyticsEvent(`ftue_prompt_roll`, 'ftue');

			return;
		}
		var showBanner = /* !store.activeMatch.fromResume || */ store.activeMatch.currentHand.rollsRemaining === 3;
		if(showBanner) {
			m.handBanner.on('animationcomplete', this.animComplete, this);
			m.playAudio("wheelSpinTicker");
			m.handBanner.anims.play('handSpin', true);
			if(store.tutorialMode && store.activeMatch.handNumber === 1 && store.activeMatch.currentHand.rollNumber === 0) {
				gameSetTimeout(m.ui.showAvaIntroBanner, 2000);
			} else
				gameSetTimeout(m.cup.returnCup, 600);

		} else {
			var handName = store.activeMatch.goals[store.activeMatch.handNumber-1];
			var frame = m.handBannerHandNames.indexOf(handName);
			if(frame < 0)
				frame = 0;
			m.handBanner.setFrame(frame);
		}
		// m.scoreCardElements.push(handBanner);
		// m.scoreCardElements.push(handBannerBack);

		if(showBanner) {
			if(store.oneTurnGame)
				gameSetTimeout(this.showRollBanner, 250);

			// if(store.tutorialMode === false){
			// 	m.rollBannerTimer = gameSetTimeout(this.showRollBanner, 1250);
			// } else {
			// 	if(store.activeMatch.handNumber !== 1){
			// 		m.rollBannerTimer = gameSetTimeout(this.showRollBanner, 1250);
			// 	}
			// }
			if(store.oneTurnGame)
				m.ui.showTurnBanner();

			if(!store.oneTurnGame && store.activeMatch.roundCount > 1) {
				m.ui.showTurnBanner();

				let over = (store.activeMatch.handNumber > 6 ? 6 : store.activeMatch.handNumber > 3 ? 3 : 0);
				let num = store.activeMatch.handNumber - over;
				//m.roundBanner = m.scene.add.sprite(m.config.width/2+m.config.width, m.handBanner.y+215, 'roundBanner'+num);
				m.roundBanner = m.scene.add.sprite(m.config.width/2+m.config.width, m.handBanner.y+184*2, 'language',  'roundBanner'+num+'.png');
				m.roundBanner.setScale(m.oldAssetScaleFactor*0.667);
				m.scoreCardElements.push(m.roundBanner);

				let roundTween = m.scene.tweens.add({
					targets     : [ m.roundBanner ],
					x: m.config.width/2,
					//   ease        : 'Expo.easeIn',
					ease		  : 'Linear',
					delay		: 600,
					duration    : 300,
					repeat      : 0,
						completeDelay: 0,
						onComplete: (tween, target) => {
							let roundBannerCopy = m.scene.add.sprite(m.roundBanner.x, m.roundBanner.y, 'language',  'roundBanner'+num+'.png');
							roundBannerCopy.setScale(m.roundBanner.scaleX);
							m.scoreCardElements.push(roundBannerCopy);
							let newY = roundBannerCopy.y + (roundBannerCopy.height * roundBannerCopy.scaleY);
							let evapTween = m.scene.tweens.add({
								targets     : [ roundBannerCopy ],
								scaleX		: 3,
								scaleY		: 3,
								y			: newY,
								alpha		: 0.0,
								ease		: 'Linear',
								duration    : 700,
								repeat      : 0
								});
							m.scoreCardTweens.push(evapTween);

							var lilStars = m.scene.add.sprite(m.roundBanner.x, m.roundBanner.y, 'poof');
							lilStars.setScale(2.65*m.scaleFactor);
							lilStars.setDepth(6);
							m.scoreCardElements.push(lilStars);
							// lilStars.on('animationcomplete', m.ui.animComplete, this);
							// m.playAudio("bumper");
							lilStars.anims.play('poof', true);
						}

				});
				m.scoreCardTweens.push(roundTween);
			}
		} else {
			m.diceHand.restoreDiceFromResume();
			m.cup.returnCup();
		}

		m.updateHeartInfo();
	}
	showTurnBanner() {
		if(store.oneTurnGame) {
			// m.turnBanner = m.scene.add.image(m.config.width/2, m.handBannerPosition+82*m.scaleFactor, 'turn_indicator_1_turn');
			// m.turnBanner.setScale(m.oldAssetScaleFactor * 1 * 1.3);
			return;
		} else
		{
			let turn = (store.activeMatch.handNumber > 6 ? 3 : store.activeMatch.handNumber > 3 ? 2 : 1);
			if(!store.tutorialMode) {
				m.turnBanner = m.scene.add.sprite(m.config.width/2, m.handBannerPosition+82*2, 'language', 'turn_indicator_'+turn+'.png');
				m.turnBanner.setScale(m.oldAssetScaleFactor * 1 * 1.3);// * (266/465));
			} else {
				m.turnBanner = m.scene.add.sprite(m.config.width/2, m.handBannerPosition+82*2, 'language', 'practice_game.png');
				m.turnBanner.setScale(m.oldAssetScaleFactor * 1 * 1.3);// * (266/465));
			}
		}
		m.scoreCardElements.push(m.turnBanner);
	}
	showAvaIntroBanner() {
		m.roundBanner.setAlpha(0);
		m.turnBanner.setAlpha(0);
		m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*0.345, "You have 3 rolls to\nget the assigned hand.\nTap ? to learn more.", true, 'tutorial_2');

		let arrow = m.scene.add.sprite((145*2), m.adjustY(-120), 'common', 'arrow_gold.png');
		arrow.setScale(0.45 * m.scaleFactor);
		m.avaPanel.add(arrow);

		let tutCont = m.ui.createButton('btn_next.png', (130*2), (m.avaFace.y-m.avaPanel.y)+m.adjustY(85), (480*m.scaleFactor)/5, m.ui.defaultButtonHeight, "Next", function (pointer) {
			integration.postAnalyticsEvent(`tutorial_next`, `tutorial`);
			console.log("tutorial roll continue");
			m.ui.clearAvaPanel();
			m.roundBanner.setAlpha(1);
			m.turnBanner.setAlpha(1);
			m.cup.returnCup();
			m.cup.reallyFakeReturnCup(true);
			// m.cup.fakeReturnCup();
			// this.destroy();
		});
		m.ui.makePulsate(tutCont);
		m.avaPanel.add(tutCont);
	}
	showRollBanner() {
		if(store.oneTurnGame) {
			let rollTheDice = m.scene.add.sprite(m.config.width/2, m.config.height*0.425, 'short_tutorial_msg_roll');
			rollTheDice.setDepth(3);
			rollTheDice.setScale(0.75*2);
			m.scoreCardElements.push(rollTheDice);
		}
		return;

		// if(m.diceStatus == "resolved")
		// 	return;
		if(true) {//m.landscape) {
			if(m.roundBanner != null)
				m.roundBanner.destroy();
			if(m.turnBanner != null)
				m.turnBanner.destroy();
		}
		var single = store.activeMatch.roundCount === 1;
		var rollBanner = m.scene.add.sprite(m.config.width/2, m.handBanner.y+((m.landscape || single) ? 170 : 180), 'language', 'placard_roll.png').setInteractive();
		rollBanner.setScale(m.assetScaleFactor);
		m.scoreCardElements.push(rollBanner);
	}

	endOfTutorialSequence() {
		var promise = Promise.resolve();
		promise = comm.FinishTutorial(true)
		.then(() => {
			// integration.postAnalyticsEvent('tutorial_end', 'tutorial');//, 'completed at initial', null, 'tutorial');
			if(store.user.xp !== 0) {
				m.ui.endTutorial();
				return;
			}
			m.ui.fadeScorecard();
			m.ui.showResults();
			m.ui.continueButtonContainer.destroy();
			return;
		});
		return;
	}

	showContinuePractice() {
		var dimPanel = m.scene.add.sprite(m.config.width/2, m.config.height/2, 'dimPanel').setInteractive();
		dimPanel.setScale(m.config.width/dimPanel.width, m.config.height/dimPanel.height);
		dimPanel.setDepth(6);
		m.scoreCardElements.push(dimPanel);
		dimPanel.setAlpha(0.6);

		let bannerContainer = m.scene.add.container(m.config.width/2, m.config.height*0.45);
		let resultsBanner = m.scene.add.sprite(0, 0, 'short_tutorial_box_keep_practicing');
		resultsBanner.setScale(m.oldAssetScaleFactor);
		bannerContainer.add(resultsBanner);
		bannerContainer.setDepth(6);

		integration.postAnalyticsEvent('tutorial_keep_practicing_prompt', 'tutorial_ftue');

		let keepPracticing = this.createButton('btn_keep_practicing', 0, 20*m.scaleFactor, 300*m.scaleFactor, (this.defaultButtonHeight*1.5), "KEEP PRACTICING", function (pointer) {
			integration.postAnalyticsEvent('tutorial_press_keep_practicing', 'tutorial_ftue');
			console.log("pressed keep practicing button");
			resultsBanner.destroy();
			bannerContainer.destroy();
			dimPanel.destroy();
			m.ui.slideOffScorecard(store.activeMatch.handNumber, false);
			store.user.hasSeenTutorial = true;
			//a bad name but accurate for the check
			window.setPersistentStorage('skippedTutorial','yes');
		});
		m.ui.makePulsate(keepPracticing);

		bannerContainer.add(keepPracticing);

		let donePracticing = this.createButton('btn_done_practicing', 0, 95*m.scaleFactor, 300*m.scaleFactor, (this.defaultButtonHeight*1.5), "KEEP PRACTICING", function (pointer) {
			integration.postAnalyticsEvent('tutorial_complete_1_and_done', 'tutorial_ftue');
			console.log("pressed done practicing button");
			resultsBanner.destroy();
			bannerContainer.destroy();
			dimPanel.destroy();
			// m.ui.slideOffScorecard(store.activeMatch.handNumber, false);
			m.ui.endOfTutorialSequence();
			store.user.hasSeenTutorial = true;
			//a bad name but accurate for the check
			window.setPersistentStorage('skippedTutorial','yes');
		});
		bannerContainer.add(donePracticing);
	}

	//level up

	doLevelUp() {
		if(!store.tutorialMode) {
			if(!store.user.xpIsCurrent){
				if(store.user.animateToLevel > store.user.level){
					store.user.updateHearts()
					.then(() => {
						m.ui.showLevelUp();
						return;
					});
					return;
				} else {
					//partial level progress animation happened at results screen prior to this
					store.user.xpAnimComplete();
				}
			}
			m.ui.showNextGameButton();
		} else {
			// if(store.user.animateToLevel > store.user.level){
				store.user.updateHearts()
				.then(() => {
					m.ui.showLevelUp();
					return;
				});
				return;
			// }
		}
	}
	showEndOfTutorialButton() {
		var y = m.adjustY(852) * ( 0.7) - 30 * m.scaleFactor;
		let x = m.config.width/2;
		let tutButton = m.ui.createButton('btn_continue_green.png', x, y, (m.adjustX(480)*0.5), (m.ui.defaultButtonHeight*1.5), "Continue", function (pointer) {
			integration.postAnalyticsEvent('tutorial_complete', 'tutorial_ftue');//, 'completed at initial', null, 'tutorial');
			if(store.activeMatch.matchId != 'intro')
				integration.postAnalyticsEvent('tutorial_complete_full', 'tutorial_ftue');//, 'completed at initial', null, 'tutorial');
			m.ui.endTutorial();
			return;
		});
		m.scoreCardElements.push(tutButton);
	}
	endTutorial() {
	// var promise = Promise.resolve();
			// promise = comm.FinishTutorial(true)
		// .then(() => {
			store.tutorialMode = false;
			store.showTutorialCompleteBubble = true;
			store.tutorialState = '';
		// });
		// integration.postAnalyticsEvent('tutorial_complete', 'tutorial', 0);//, 'completed at initial', null, 'tutorial');
		store.tutorialMode = false;
		integration.onTutorialCompleted();
		store.user.hasSeenTutorial = true;
		store.getLobbyData().then(() => {
  history.push('/');
})
	}

	fadeObject(targetObject) {
		m.scene.tweens.add({
			targets     : [ targetObject ],
			alpha: 0,
			ease		: 'Linear',
			duration    : 150, repeat      : 0,
			delay		: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				targetObject.destroy();
			}
		});
	}
	showLevelUp() {
		if(m.bannerContainer)
			m.ui.fadeObject(m.bannerContainer);
		if(m.ui.finalResultsMsg)
			m.ui.fadeObject(m.ui.finalResultsMsg);
		if(m.ui.resultsRays)
			m.ui.fadeObject(m.ui.resultsRays);

		m.clearMessages();

		//TODO: REMOVE FROM SPRITE SHEET
		var dimPanel = m.scene.add.sprite(m.config.width/2, m.config.height/2, 'dimPanel');
		dimPanel.setScale(m.config.width/dimPanel.width, m.config.height/dimPanel.height);
		dimPanel.setDepth(3);
		m.scoreCardElements.push(dimPanel);

		let levelUpContainer = m.scene.add.container(m.config.width/2, m.adjustY(350));

		//TODO: Remove the unnecessary tutorial sheet, and hardcode the values
		let levelUpBanner;
		if(store.tutorialMode){
			levelUpBanner = m.scene.add.sprite(0, 0, 'tutorial', 'levelUpBoxWithBannerTutorial.png');
		}else{
			levelUpBanner = m.scene.add.sprite(0, 0, 'language', 'levelUpBoxWithBanner.png');
		}

		levelUpBanner.setScale(m.oldAssetScaleFactor);
		m.scoreCardElements.push(levelUpBanner);
		levelUpContainer.add(levelUpBanner);
		levelUpContainer.setDepth(6);

		let heartsGained = store.tutorialMode ? 10 : store.user.heartsGained;

		let heart = m.scene.add.sprite(m.adjustY(70), m.adjustY(36), 'common', 'pinkHeart.png');
		heart.setScale(m.oldAssetScaleFactor*1.1, m.oldAssetScaleFactor*1.1);
		levelUpContainer.add(heart);

		if(!store.tutorialMode) {
			let star = m.scene.add.sprite(m.adjustX(-70), m.adjustY(29), 'common', 'levelUp_star.png');
			star.setScale(m.oldAssetScaleFactor);
			let starNumText = store.tutorialMode ? 2 : store.user.animateToLevel;
			levelUpContainer.add(star);
			let starNum = m.scene.add.text(star.x, star.y+2*m.scaleFactor, starNumText,
				{ fontFamily: m.ui.dodFontFamily, fontSize: '76px', fill: '#6a2c00',
				shadow: { offsetX: 2, offsetY: 2, color: '#ffe474', blur: 0, stroke: false, fill: true },
				});
			starNum.setOrigin(0.5, 0.5);
			levelUpContainer.add(starNum);


			if(heartsGained > 0) {
				let heartNum = m.scene.add.text(heart.x-2, heart.y-6, '+'+heartsGained,
					{ fontFamily: m.ui.dodFontFamily, fontSize: '66px', fill: '#ffffff', shadow: { offsetX: 1, offsetY: 1, color: '#000000', blur: 3, stroke: false, fill: true },
					});
				heartNum.setOrigin(0.5, 0.5);
				levelUpContainer.add(heartNum);
			}
		} else
			heart.setAlpha(0);

		let targetY = levelUpContainer.y;
		levelUpContainer.y -= m.config.height;

		m.playAudio('RewardsPopupStars');

		m.scene.tweens.add({
			targets     : [ levelUpContainer ],
			y			: targetY+30*m.scaleFactor,
			ease		: 'Linear',
			duration    : 500, repeat      : 0,
			delay		: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				m.scene.tweens.add({
					targets     : [ levelUpContainer ],
					y			: targetY,
					ease		: 'Linear',
					duration    : 150, repeat      : 0,
					delay		: 0,
					completeDelay: 0,
					onComplete: (tween, target) => {
						//TODO: Remove from Sprite Sheet
						var rays = m.scene.add.sprite(m.config.width/2, levelUpContainer.y, 'rays');
						rays.setScale(m.oldAssetScaleFactor*0.9);
						rays.setAlpha(0.75);
						rays.setDepth(3);
						m.scoreCardElements.push(rays);
						var rayTween = m.scene.tweens.add({
							targets     : [ rays ],
							angle		: 360,
							ease		: 'Linear',
							duration    : 5000,
							repeat      : -1
							});
						m.scoreCardTweens.push(rayTween);
						m.scoreCardElements.push(levelUpContainer);

						if(heartsGained > 0)
							m.ui.showHeartsLevelUp(levelUpContainer.x+heart.x+20*m.scaleFactor, levelUpContainer.y+heart.y-40*m.scaleFactor, 4);

						let floatingStars = m.scene.add.sprite(levelUpContainer.x, levelUpContainer.y, 'floatingStars001');
						floatingStars.setScale(1.0*m.scaleFactor);
						floatingStars.setDepth(6);
						floatingStars.anims.play('floatingStars');
						m.scoreCardElements.push(floatingStars);

						integration.postAnalyticsEvent(`levelup`, `economy`, store.user.level);

						store.user.levelUpComplete();

						if(store.tutorialMode) {
							store.user.updateXp().then(() => {
								store.user.xpAnimComplete();
								m.ui.updateProgressBar(false, 500);
								m.updateLevelInfo();
								gameSetTimeout(m.ui.showEndOfTutorialButton, 2700);
							});
						} else {
							store.user.xpAnimComplete();
							m.ui.updateProgressBar(false, 500);
							m.updateLevelInfo();
							gameSetTimeout(m.ui.showNextGameButton, 2700);
						}
					}
				});
			}
		});
	}

	showHeartsLevelUp(x, y, num) {
		var delay = 500;
		for(var i=0;i < num;i++, delay+=250)
			gameSetTimeout(m.ui.showHeartLevelUp, delay, x, y, i);
		gameSetTimeout(m.ui.completeHeartsLevelUp, 500+350+num*250);
	}
	completeHeartsLevelUp() {
		store.user.heartAnimComplete();
		m.updateHeartInfo();
	}
	showHeartLevelUp(x, y, num) {
		var delay = 0;
		// for(var i=0;i < num;i++, delay+=300)
		{
			let heart = m.scene.add.sprite(x, y, 'common', 'pinkHeart.png');
			heart.setScale(m.oldAssetScaleFactor*1.2, m.oldAssetScaleFactor*1.2);
			heart.setAlpha(0.75);
			heart.setDepth(6);
			// heart.num = num;
			// m.scoreCardElements.push(star);
			let oldScaleX = heart.scaleX;
			let oldScaleY = heart.scaleY;
			m.scene.tweens.add({
				targets     : [ heart ],
				x: m.gameHud.x+m.adjustX(146), y: m.gameHud.y+m.gameHud.hudBackHeight/2-1*m.scaleFactor,
				alpha: 1.0,
				ease		: 'Linear',
				duration    : 350, repeat      : 0,
				delay		: delay,
				completeDelay: 0,
				onComplete: (tween, target) => {
					m.scene.tweens.add({
						targets     : [ heart ],
						scaleX: oldScaleX * 1.1, scaleY: oldScaleY * 1.1,
						ease		: 'Linear',
						duration    : 75, repeat      : 0,
						delay		: 0,
						completeDelay: 0,
						onComplete: (tween, target) => {

							m.scene.tweens.add({
								targets     : [ heart ],
								scaleX: oldScaleX, scaleY: oldScaleY,
								alpha: 0,
								ease		: 'Linear',
								duration    : 50, repeat      : 0,
								delay		: 0,
								completeDelay: 0,
								onComplete: (tween, target) => {
									heart.destroy();
								}
							});
						}
					});
				}
			});
		}
	}

	//end levelup

	showResults() {
		//send winnings, unless this is a 2nd play of the tutorial
		if(!store.tutorialMode || !store.user.hasSeenTutorial){
			integration.onMatchResult(store.activeMatch.winAmount);
		}
		var winner, tie, oppWinner;
		if(store.oneTurnGame) {
			winner = store.activeMatch.hands[0].isWinner && store.activeMatch.hands[0].match && store.activeMatch.hands[0].match.length > 2;
			oppWinner = store.activeMatch.opponent.hands[0].isWinner && store.activeMatch.opponent.hands[0].match && store.activeMatch.opponent.hands[0].match.length > 2;
			tie = winner && oppWinner;
		} else {
			winner = m.myTotalScore > m.opponentTotalScore;
			tie =  m.myTotalScore === m.opponentTotalScore;
		}
		// tie = true; winner = false;

		var extraScale = store.tutorialMode ? 1.0 : 1.25;
		var resultsPanelY = 350 * m.scaleFactor;

		m.bannerContainer = m.scene.add.container(m.config.width/2, resultsPanelY);
		if(store.tutorialMode) {

			//TODO: Remove extra image assets and just hardcode values
			m.resultsBanner = m.scene.add.sprite(0, 0, 'tutorial', 'box_practice_turn_complete.png');
			m.resultsBanner.setScale(m.oldAssetScaleFactor);
			integration.postAnalyticsEvent('tutorial_achievement', 'tutorial');
		} else {
			m.resultsBanner = m.scene.add.sprite(0, 0, 'language', tie ? 'end_game_box_tie.png' : /* winner ? */ 'end_game_box.png');// : */ 'resultsBanner');
			m.resultsBanner.setScale((m.oldAssetScaleFactor)*0.75);
		}
		m.scoreCardElements.push(m.resultsBanner);
		m.bannerContainer.add(m.resultsBanner);
		m.bannerContainer.setScale(0.25);
		m.bannerContainer.setDepth(4);

		m.scene.tweens.add({
			targets     : [ m.bannerContainer ],
			scaleX: extraScale, scaleY: extraScale,
			ease		: 'Linear',
			duration    : 250, repeat      : 0,
			delay		: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {

				if(!store.tutorialMode) {
					var targetSize = this.resultsProfilePicTargetSize;
					var x = store.oneTurnGame ? (m.bannerContainer.x-100*m.scaleFactor) : m.pLeft.x;
					var y = store.oneTurnGame ? (m.bannerContainer.y - 8*m.scaleFactor) : m.pLeft.y;
					m.resultsProfilePic = m.ui.makeProfilePic(x, y, targetSize, m.ui.myPortraitName);
					m.scoreCardElements.push(m.resultsProfilePic);
					x = store.oneTurnGame ? (m.bannerContainer.x+100*m.scaleFactor) : m.pRight.x;
					y = store.oneTurnGame ? (m.bannerContainer.y - 8*m.scaleFactor) : m.pRight.y;
					m.resultsOpponentPic = m.ui.makeProfilePic(x, y, targetSize, m.ui.portraitBotName);
					m.scoreCardElements.push(m.resultsOpponentPic);
		
					if(store.oneTurnGame) {
						m.ui.showOneTurnResultsStars();
						// gameSetTimeout(m.ui.showOneTurnResultsStars, 4000);
					} else {
						if(winner || tie) {
							m.resultsStarsContainer = m.ui.createStarsContainer(m.resultsProfilePic.x, m.resultsProfilePic.y, targetSize);
							m.scoreCardElements.push(m.resultsStarsContainer);
						}
						if(!winner || tie) {
							m.opponentResultsStarsContainer = m.ui.createStarsContainer(m.resultsOpponentPic.x, m.resultsProfilePic.y, targetSize);
							m.scoreCardElements.push(m.opponentResultsStarsContainer);
						}
					}
					m.ui.continueShowResults();
		
					if(!store.oneTurnGame)
						m.ui.startMovePics();
				} else {
					m.ui.continueShowResults();
				}
		
			}
		});

	}

	showOneTurnResultsStars() {
		var targetSize = this.resultsProfilePicTargetSize;
		let winner = store.activeMatch.hands[0].isWinner && store.activeMatch.hands[0].match && store.activeMatch.hands[0].match.length > 2;
		let oppWinner = store.activeMatch.opponent.hands[0].isWinner && store.activeMatch.opponent.hands[0].match && store.activeMatch.opponent.hands[0].match.length > 2;
		if(winner) {
			m.resultsStarsContainer = m.ui.createStarsContainer(m.resultsProfilePic.x, m.resultsProfilePic.y, targetSize);
			m.scoreCardElements.push(m.resultsStarsContainer);
			m.resultsStarsContainer.setAlpha(0);
			gameSetTimeout(m.ui.showOneTurnMyStars, 2100);
		}
		if(oppWinner) {
			m.opponentResultsStarsContainer = m.ui.createStarsContainer(m.resultsOpponentPic.x, m.resultsProfilePic.y, targetSize);
			m.scoreCardElements.push(m.opponentResultsStarsContainer);
			m.opponentResultsStarsContainer.setAlpha(0);
			gameSetTimeout(m.ui.showOneTurnHisStars, 2100, !winner);
		}
		if(!winner && !oppWinner)
			gameSetTimeout(m.playAudio, 2100, 'finalLosing');
	}
	showOneTurnMyStars() {
		m.resultsStarsContainer.setAlpha(1);
		m.playAudio('scorescreen_leadin_totalCelebration');
	}
	showOneTurnHisStars(sfx) {
		m.opponentResultsStarsContainer.setAlpha(1);
		if(sfx)
			m.playAudio('finalLosing');
	}
	resultsRays = null;
	continueShowResults () {
		if(!store.tutorialMode) {
			var winner = m.myTotalScore > m.opponentTotalScore;
			var tie = m.myTotalScore === m.opponentTotalScore;
			var myName, hisName, myScore, hisScore, myXp;

			if(!store.oneTurnGame)
				if((winner && (!m.landscape || store.activeMatch.roundCount === 1)) || tie) {

					//TODO: Remove from Sprite Sheet
					m.ui.resultsRays = m.scene.add.sprite(m.config.width/2, m.bannerContainer.y, 'rays');
					m.ui.resultsRays.setScale(m.oldAssetScaleFactor * 1.0);
					m.ui.resultsRays.setAlpha(0.75);
					m.ui.resultsRays.setDepth(3);
					m.scoreCardElements.push(m.ui.resultsRays);
					var rayTween = m.scene.tweens.add({
						targets     : [ m.ui.resultsRays ],
						angle		: 360,
						ease		: 'Linear',
						duration    : 5000,
						repeat      : -1
						});
					m.scoreCardTweens.push(rayTween);
				}

			let targetSize = 222 * 0.4 * m.bannerContainer.scaleX * 1.25;
			targetSize *= m.scaleFactor;

			let name = " "+m.getUsername()+" ";
			let nameOffset = targetSize* (0.5);

			let myX = (m.bannerContainer.x-100* m.scaleFactor);
			let myY = (m.bannerContainer.y - 48* m.scaleFactor);
			let oppX = (m.bannerContainer.x+100* m.scaleFactor);
			let oppY = (m.bannerContainer.y - 48* m.scaleFactor);

			if(store.oneTurnGame) {
				myY = (m.bannerContainer.y - 4* m.scaleFactor);
				oppY = (m.bannerContainer.y - 4* m.scaleFactor);

			}

			let blur = 0;
			let offset = 2;

			myName = m.scene.add.text(myX, myY+nameOffset, name,
				{ fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#9f5305', strokeThickness: 3,
				});
			myName.setOrigin(0.5,0.5);
			myName.setDepth(6);
			m.scoreCardElements.push(myName);
			let plateHeight = (myName.height+2);
			m.ui.createNameplate(myName.x-myName.displayWidth/2, myName.y-(plateHeight/2), myName.displayWidth, plateHeight, 10, 0xff9226, 1.0, 0x9f5205, 5);

			if(!store.oneTurnGame) {
				myScore = m.scene.add.text(myX, myY+nameOffset+48* m.scaleFactor, m.finalScoreLeft.text,
					{ fontFamily: m.ui.dodFontFamily, fontSize: '120px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: offset, color: '#000000', blur: blur, stroke: false, fill: true },
					});
					myScore.setOrigin(0.5,0.5);
					myScore.setDepth(5);
					myScore.setAlpha(0);
				m.scoreCardElements.push(myScore);

				myXp = m.scene.add.text(myX, myY+nameOffset+92* m.scaleFactor, "+"+m.finalScoreLeft.text+" XP",
					{ fontFamily: m.ui.dodFontFamily, fontSize: '60px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: offset, color: '#000000', blur: blur, stroke: false, fill: true }
					});
					myXp.setOrigin(0.5,0.5);
					myXp.setDepth(5);
					myXp.setAlpha(0);
				m.scoreCardElements.push(myXp);
			}

			let oppNameToUse = store.activeMatch.opponent.name ? store.activeMatch.opponent.name : "Opponent";
			oppNameToUse = ' '+oppNameToUse+' ';
			hisName = m.scene.add.text(oppX, oppY+nameOffset, oppNameToUse,// store.activeMatch.opponent.name,
				{ fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#9f5305', strokeThickness: 3,
				});
			hisName.setOrigin(0.5,0.5);
			hisName.setDepth(6);
			m.scoreCardElements.push(hisName);
			m.ui.createNameplate(hisName.x-hisName.displayWidth/2, hisName.y-(plateHeight/2), hisName.displayWidth, plateHeight, 10, 0xff9226, 1.0, 0x9f5205, 5);

			if(!store.oneTurnGame) {
				hisScore = m.scene.add.text(oppX, oppY+nameOffset+48* m.scaleFactor, m.finalScoreRight.text,
					{ fontFamily: m.ui.dodFontFamily, fontSize: '120px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: offset, color: '#000000', blur: blur, stroke: false, fill: true },
					});
					hisScore.setOrigin(0.5,0.5);
					hisScore.setDepth(5);
					hisScore.setAlpha(0);
				m.scoreCardElements.push(hisScore);

				m.scene.tweens.add({
					targets     : [ myScore, myXp, hisScore ],
					alpha		: 1.0,
					ease		  : 'Linear',
					duration    : 700,
					repeat      : 0
				});
			}

			if(!store.oneTurnGame) {
				for(let del=800, i=0;i < 5;i++, del += 250) {
					gameSetTimeout(m.ui.showStarsXP, del, myX, myY+nameOffset+80, 5);
				}
				m.ui.updateProgressBar(true, 1200);
			} else {
				let hand = 0;
				let myHand = store.activeMatch.hands[hand];
				let opponentHand = store.activeMatch.opponent.hands[hand];
				m.ui.oneHandTurnCheckMark1 = null;
				m.ui.oneHandTurnCheckMark2 = null;

				let winner = store.activeMatch.hands[0].isWinner && store.activeMatch.hands[0].match && store.activeMatch.hands[0].match.length > 2;
				let oppWinner = store.activeMatch.opponent.hands[0].isWinner && store.activeMatch.opponent.hands[0].match && store.activeMatch.opponent.hands[0].match.length > 2;
		
				let slowDown = 1;

				let leftContainer = m.scene.add.container(m.bannerContainer.x+(-85 * m.scaleFactor), m.bannerContainer.y + (110 * m.scaleFactor));
				leftContainer.setScale(1.25);
				leftContainer.setDepth(4);
				leftContainer.alpha = 0;
				m.ui.showOneTurnCardHand(myHand, hand, 0, 0, leftContainer, winner);
				gameSetTimeout(m.ui.showOneTurnCardHand, 700, myHand, hand, -65 * m.scaleFactor, 90 * m.scaleFactor, m.bannerContainer, winner);
				gameSetTimeout(() => {
					leftContainer.alpha = 1.0;
					m.scene.tweens.add({
						targets     : [ leftContainer ],
						alpha		: 0.0,
						scaleX: 3.0, scaleY: 3.0,
						ease		  : 'Linear',
						duration    : 700*slowDown,
						repeat      : 0
					});
				}, 700);

				let rightContainer = m.scene.add.container(m.bannerContainer.x+(116 * m.scaleFactor), m.bannerContainer.y+(110 * m.scaleFactor));
				rightContainer.setScale(1.25);
				rightContainer.setDepth(5);
				rightContainer.alpha = 0.0;
				m.ui.showOneTurnCardHand(opponentHand, hand, 0, 0, rightContainer, oppWinner);
				gameSetTimeout(m.ui.showOneTurnCardHand, 1400*slowDown, opponentHand, hand, 96 * m.scaleFactor, 90 * m.scaleFactor, m.bannerContainer, oppWinner);
				gameSetTimeout(() => {
					rightContainer.alpha = 1.0;
					m.scene.tweens.add({
						targets     : [ rightContainer ],
						alpha		: 0.0,
						scaleX: 3.0, scaleY: 3.0,
						ease		  : 'Linear',
						duration    : 700*slowDown,
						repeat      : 0
					});
				}, 1400*slowDown);

				if(winner)
					gameSetTimeout(m.ui.showOneTurnCheckMark1, 2100);
				if(oppWinner)
					gameSetTimeout(m.ui.showOneTurnCheckMark2, 2100);
			}

			m.scoreCardElements.push(m.bannerContainer);

			if(!store.oneTurnGame) {
				if(!tie)
					m.playAudio(winner ? 'gameEndSequenceWin' : 'finalLosing');
				else
					m.playAudio('bumper');
			}

			integration.postAnalyticsEvent(`roll_complete`, `gameplay`, m.myTotalScore);

			if(store.oneTurnGame)
				m.ui.showNextGameButton();
			else
				gameSetTimeout(m.ui.doLevelUp, 5000);

		} else { //tutorial mode

			store.user.updateXp().then(() => {
				for(let del=800, i=0;i < 5;i++, del += 250) {
					gameSetTimeout(m.ui.showStarsXP, del, m.config.width*0.3, m.bannerContainer.y, 5);
				}
				m.ui.updateProgressBar(true, 1200);

				m.scoreCardElements.push(m.bannerContainer);

				m.playAudio('gameEndSequenceWin');

				gameSetTimeout(m.ui.doLevelUp, 5000);

				// store.user.xpAnimComplete();
			});

		}
	}
	showOneTurnCardHand (hand, handNum, x, y, container, winner ) {
		let reduce = 0.9;
		var validHand = hand.match && (hand.match.length > 2);
		var diceInHand = validHand ? hand.match.length : 0;
		var diceOffset = 33 * m.scaleFactor;
		diceOffset *= reduce;
		if(!validHand) {
			let handName = store.activeMatch.goals[handNum];

			if(!handName || handName == null || handName == undefined && (typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
				handName = store.activeMatch.currentHand.bestHandTargetString;

			let index = m.handBannerHandNames.indexOf(handName);
			if(index < 0)
				diceInHand = 0;
			else
				diceInHand = m.dicePerHandType[index];
		}
		if(!validHand && handNum === 8)	//show frowns for jackpot hand if not achieved
			diceInHand = 5;
		let diceInHandWidth = (diceInHand * diceOffset);
		let leftEdge = x - (diceInHandWidth / 2);
		var tinyY = y+3 * m.scaleFactor;
		for(let d=0;d < diceInHand;d++) {
			let tinyX = (leftEdge)+d*diceOffset;
			// player
			let tinyDice1;
			if(validHand) {
				let highlight = m.scene.add.sprite(tinyX, tinyY, 'common', 'BlueBoxSprite.png');
				container.add(highlight);
				highlight.setScale(0.775 * m.scaleFactor * reduce);
				m.scoreCardElements.push(highlight);
				tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'dice2D_sheet_64');
				container.add(tinyDice1);
				tinyDice1.setScale(m.diceTinyScale * (m.diceOldFullRes/m.diceFullRes) * 226/64 * reduce);
				let index = hand.match[d];
				let face = hand.dice[index].showing;
				let num = ((index*6)+face);
				tinyDice1.setFrame(num);
			} else {
				tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'common', 'dice_frown_40.png');
				container.add(tinyDice1);
				tinyDice1.setScale((0.825 * 40/64) * m.scaleFactor * reduce);
			}
			m.scoreCardElements.push(tinyDice1);

			if(!(x === 0 && y === 0))
				if(d === diceInHand-1) {
					if(m.ui.oneHandTurnCheckMark1 === null) {
						m.ui.oneHandTurnCheckMark1 = m.scene.add.sprite(tinyX+diceOffset*0.625, tinyY-diceOffset*0.625,  'check_1_turn');
						container.add(m.ui.oneHandTurnCheckMark1);
						m.ui.oneHandTurnCheckMark1.setScale(0.275 * m.scaleFactor);
						m.ui.oneHandTurnCheckMark1.setAlpha(0);
					} else {
						m.ui.oneHandTurnCheckMark2 = m.scene.add.sprite(tinyX+diceOffset*0.625, tinyY-diceOffset*0.625,  'check_1_turn');
						container.add(m.ui.oneHandTurnCheckMark2);
						m.ui.oneHandTurnCheckMark2.setScale(0.275 * m.scaleFactor);
						m.ui.oneHandTurnCheckMark2.setAlpha(0);
					}
				}
		}
		var validHand = hand.match && (hand.match.length > 2);	
		if(!(x === 0 && y === 0))
			m.playAudio(validHand ? 'correctHand' : 'noHand');
	}

	showOneTurnCheckMark1() {
		m.ui.oneHandTurnCheckMark1.setAlpha(1);
		// m.playAudio('bumper');
	}
	showOneTurnCheckMark2() {
		m.ui.oneHandTurnCheckMark2.setAlpha(1);
		// m.playAudio('bumper');
	}
	oneHandTurnCheckMark1 = null;
	oneHandTurnCheckMark2 = null;

	clearResultsStuff(s1, s2, s3, s4, s5, s6, s7, s8) {
		if(s1 != null)
			s1.destroy();
		if(s2 != null)
			s2.destroy();
		if(s3 != null)
			s3.destroy();
		if(s4 != null)
			s4.destroy();
		if(s5 != null)
			s5.destroy();
		if(s6 != null)
			s6.destroy();
		if(s7 != null)
			s7.destroy();
		if(s8 != null)
			s8.destroy();
		if(m.opponentResultsStarsContainer != null)
			m.opponentResultsStarsContainer.destroy();

	}
	finalResultsMsg = null;

	showStarsXP(x, y, num) {
		// for(var i=0;i < num;i++) {
			let star = m.scene.add.sprite(x, y, 'common', 'levelUp_star.png');
			star.setAlpha(0.75);
			star.setScale(m.oldAssetScaleFactor*0.75);
			star.setDepth(6);
			// m.scoreCardElements.push(star);
			let oldScale = star.scaleX;
			m.scene.tweens.add({
				targets     : [ star ],
				x: m.gameHud.x + m.adjustX(-132), y: m.gameHud.y+m.gameHud.hudBackHeight/2-5,
				alpha: 1.0,
				ease		: 'Linear',
				duration    : 400, repeat      : 0,
				delay		: 0,
				completeDelay: 0,
				onComplete: (tween, target) => {
					m.scene.tweens.add({
						targets     : [ star ],
						scaleX: oldScale * 1.2, scaleY: oldScale * 1.2,
						ease		: 'Linear',
						duration    : 75, repeat      : 0,
						delay		: 0,
						completeDelay: 0,
						onComplete: (tween, target) => {

							m.scene.tweens.add({
								targets     : [ star ],
								scaleX: oldScale, scaleY: oldScale,
								alpha: 0,
								ease		: 'Linear',
								duration    : 50, repeat      : 0,
								delay		: 0,
								completeDelay: 0,
								onComplete: (tween, target) => {
									star.destroy();
								}
							});
						}
					});
				}
			});
		// }
	}

	//custom hacked movement tween for masked object (phaser tween has issues w/ tweening masks)
	picDeltaX = 0;
	picDeltaY = 0;
	oppDeltaX = 0;
	oppDeltaY = 0;
	picTicks = 0.500 / (1/30);
	startMovePics = () => {
		let winner = m.myTotalScore >= m.opponentTotalScore;
		let tie = m.myTotalScore === m.opponentTotalScore;
		if(winner || tie)
			m.playAudio('chestConfetti');

		this.picDeltaX = (m.bannerContainer.x-100*m.scaleFactor) - m.resultsProfilePic.x;
		this.picDeltaY = (m.bannerContainer.y - 8*m.scaleFactor) - m.resultsProfilePic.y;
		this.oppDeltaX = (m.bannerContainer.x+100*m.scaleFactor) - m.resultsOpponentPic.x;
		this.oppDeltaY = (m.bannerContainer.y - 8*m.scaleFactor) - m.resultsOpponentPic.y;
		this.movePics();
	}
	movePics = () => {
		var movedX = false;
		var movedY = false;
		var changeX = this.picDeltaX / this.picTicks;
		var changeY = this.picDeltaY / this.picTicks;
		var oppChangeX = this.oppDeltaX / this.picTicks;
		var oppChangeY = this.oppDeltaY / this.picTicks;
		if(m.resultsProfilePic.x < m.bannerContainer.x-100*m.scaleFactor) {
			m.resultsProfilePic.x += changeX;
			m.resultsProfilePic.shape.x += changeX;
			m.resultsOpponentPic.x += oppChangeX;
			m.resultsOpponentPic.shape.x += oppChangeX;
			movedX = true;
		}
		if(m.resultsProfilePic.y < m.bannerContainer.y - 48*m.scaleFactor) {
			m.resultsProfilePic.y += changeY;
			m.resultsProfilePic.shape.y += changeY;
			m.resultsOpponentPic.y += oppChangeY;
			m.resultsOpponentPic.shape.y += oppChangeY;
			movedY = true;
		}

		let winner = m.myTotalScore >= m.opponentTotalScore;
		let tie = m.myTotalScore === m.opponentTotalScore;
		if(winner || tie) {
			m.resultsStarsContainer.x = m.resultsProfilePic.x;
			m.resultsStarsContainer.y = m.resultsProfilePic.y;
		}
		if(!winner || tie) {
			m.opponentResultsStarsContainer.x = m.resultsOpponentPic.x;
			m.opponentResultsStarsContainer.y = m.resultsOpponentPic.y;
		}
		if(movedX === true || movedY === true)
			gameSetTimeout(this.movePics, 500 / this.picTicks);
		else {
			m.ui.addLevelStar(m.resultsProfilePic, m.ui.resultsProfilePicTargetSize, store.user.level);
			if(!store.activeMatch.opponent.isBot && store.activeMatch.opponent.level)
				m.ui.addLevelStar(m.resultsOpponentPic, m.ui.resultsProfilePicTargetSize, store.activeMatch.opponent.level);
		}
	}
	// ***

	showScorecardHandName(x, y, handName) {
		//temporarily replace up to 3 hyphens (should be done on server)
		handName = handName.replace("-", "_");
		handName = handName.replace("-", "_");
		handName = handName.replace("-", "_");
		handName = i18n.t(handName);
		handName = '  '+handName+'  ';
		var jPot = m.scene.add.text(x, y, handName, { fontFamily: 'Jost', fontSize: '36px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: 2, color: '#000', blur: 0, stroke: false, fill: true } });
		jPot.setDepth(4);
		jPot.setOrigin(0,0.5);

		let plateHeight = (jPot.height+2);
		m.ui.createNameplate(x, y-(plateHeight/2), jPot.displayWidth, plateHeight, 5, 0xa26325, 0.5, 0, 3, m.scoreCardContainer);

		m.scoreCardContainer.add(jPot);
		m.scoreCardElements.push(jPot);
	}

	showScorecardHandTray (count, leftEdge, y, showQmarks) {
		var diceInHand = count > 0 ? count : 5;
		var diceOffset = 33 * m.scaleFactor;
		for(let d=0;d < diceInHand;d++) {
			var tinyX = (leftEdge)+d*diceOffset;
			var tinyY = y+3*m.scaleFactor;
			var useQuestion = false;// (/*(store.tutorialMode || store.activeMatch.roundCount === 1) && */ leftEdge > 0);
			useQuestion |= showQmarks;
			var tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'common', useQuestion ? 'dice_Q_40.png' : 'lil_brown_box.png');
			m.scoreCardContainer.add(tinyDice1);
			var scale = 0.625 *m.scaleFactor;
			if(useQuestion)
				scale *= (54/40 * 40/64);
			else {
				tinyDice1.setAlpha(0.4);
				scale *= 0.975;
			}
			tinyDice1.setScale(scale);
			m.scoreCardElements.push(tinyDice1);
		}
	}
	scoreFontSize = '52px';
	showScoreCardHand (hand, handNum, x, y, leftEdge, sfx, isOpponent ) {
		var scoreText = m.scene.add.text(x, y,  hand.score > 0 ? hand.score : '-',
			{ fontFamily: m.ui.dodFontFamily,
				fontSize: m.ui.scoreFontSize,
				fill: '#ffffff', shadow: { offsetX: 0, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true }
			});
			m.scoreCardContainer.add(scoreText);
			scoreText.setOrigin(0.5, 0.5);
			if(!isOpponent)
				m.scoreCardHands.push(scoreText);
			else
				m.scoreCardOpponentHands.push(scoreText);

		var validHand = hand.match && (hand.match.length > 2);
		var diceInHand = validHand ? hand.match.length : 0;
		var diceOffset = 33 * m.scaleFactor;
		if(!validHand) {
			let handName = store.activeMatch.goals[handNum];

			if(!handName || handName == null || handName == undefined && (typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
				handName = store.activeMatch.currentHand.bestHandTargetString;

			let index = m.handBannerHandNames.indexOf(handName);
			if(index < 0)
				diceInHand = 0;
			else
				diceInHand = m.dicePerHandType[index];
		}
		if(!validHand && handNum === 8)	//show frowns for jackpot hand if not achieved
			diceInHand = 5;
		var tinyY = y+3 * m.scaleFactor;
		for(let d=0;d < diceInHand;d++) {
			let tinyX = (leftEdge)+d*diceOffset;
			// player
			let tinyDice1;
			if(validHand) {
				let highlight = m.scene.add.sprite(tinyX, tinyY, 'common', 'BlueBoxSprite.png');
				m.scoreCardContainer.add(highlight);
				highlight.setScale(0.775 * m.scaleFactor);
				m.scoreCardElements.push(highlight);
				tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'dice2D_sheet_64');
				m.scoreCardContainer.add(tinyDice1);
				tinyDice1.setScale(m.diceTinyScale * (m.diceOldFullRes/m.diceFullRes) * 226/64);
				let index = hand.match[d];
				let face = hand.dice[index].showing;
				let num = ((index*6)+face);
				tinyDice1.setFrame(num);
			} else {
				tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'common', 'dice_frown_40.png');
				m.scoreCardContainer.add(tinyDice1);
				tinyDice1.setScale((0.825 * 40/64) * m.scaleFactor);
			}
			m.scoreCardElements.push(tinyDice1);
		}
		if(/*validHand &&  */sfx && m.ui.scoreDelay > 10) {
			let blueOutLine = m.scene.add.sprite(leftEdge+(diceInHand*diceOffset)/2-diceOffset/2, tinyY, 'blueBoxSprites');
			blueOutLine.setScale(0.75 * m.scaleFactor);
			blueOutLine.setAlpha(0.5 * m.scaleFactor);
			blueOutLine.setFrame(diceInHand-3);
			m.scoreCardContainer.add(blueOutLine);
			m.scoreCardElements.push(blueOutLine);
			let evapTween = m.scene.tweens.add({
				targets     : [ blueOutLine ],
				scaleX		: 3 * m.scaleFactor,
				scaleY		: 3 * m.scaleFactor,
				alpha		: 0.0,
				ease		: 'Linear',
				duration    : 700,
				repeat      : 0
				});
			m.scoreCardTweens.push(evapTween);
		}

		var baseHandNum = handNum >= 6 ? 6 : handNum >= 3 ? 3 : 0;

		if(x < 0) {
			let scoreSoFar = m.myLowerBonusScore + m.myUpperBonusScore;// 0;
			for(let i=0;i <= handNum;i++) {
				if(i === handNum || i >= baseHandNum)
					scoreSoFar += store.activeMatch.hands[i].score;
				else
					scoreSoFar += (store.activeMatch.hands[i].isWinner ? store.activeMatch.hands[i].finalScore : store.activeMatch.hands[i].score);
			}
			m.finalScoreLeft.text = scoreSoFar;
		} else {
			let scoreSoFar = m.opponentLowerBonusScore + m.opponentUpperBonusScore;
			for(let i=0;i <= handNum;i++)
				if(i === handNum)
					scoreSoFar += store.activeMatch.opponent.hands[i].score;
				else
					scoreSoFar += (store.activeMatch.opponent.hands[i].isWinner ? store.activeMatch.opponent.hands[i].finalScore : store.activeMatch.opponent.hands[i].score);

				m.finalScoreRight.text = scoreSoFar;
		}
		if(sfx && m.ui.scoreDelay > 10)
			m.playAudio(validHand ? 'correctHand' : 'noHand');
	}

	showFinalHandScore(handNum, sfx) {
		var purpleSpotToUse = 'scorecardBlueSpot.png';
		var myHand = store.activeMatch.hands[handNum];
		var opponentHand = store.activeMatch.opponent.hands[handNum];
		var mySpot = null, hisSpot = null;
		let myCurrentScore = myHand.finalScore, hisCurrentScore = opponentHand.finalScore;
		if(myHand.isWinner) {
			if(store.tutorialMode && store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 0){
				store.tutorialState = 'twopairscore';
			}
			let textIndex = handNum;// store.tutorialMode ? handNum * 2 : handNum;
			let oldText = m.scoreCardHands[textIndex];
			let oldNum = parseInt(oldText.text);
			if(oldNum)
				myCurrentScore = oldNum;
			let x = oldText.x;
			let y = oldText.y;
			oldText.destroy();

			if(myHand.finalScore > 0) {
				mySpot = m.scene.add.sprite(x, y, 'common', purpleSpotToUse);
				m.scoreCardContainer.add(mySpot);
				mySpot.setScale((m.oldAssetScaleFactor*1.25));
				mySpot.setOrigin(0.5, 0.5);
				m.scoreCardElements.push(mySpot);
			}

			let scoreText = m.scene.add.text(x, y, myHand.finalScore > 0 ? myHand.finalScore : '-',
				{ fontFamily: m.ui.dodFontFamily,
					fontSize: m.ui.scoreFontSize,
					fill: '#ffffff', shadow: { offsetX: 0, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true }
				});
			m.scoreCardContainer.add(scoreText);
			scoreText.setOrigin(0.5, 0.5);
			m.scoreCardElements.push(scoreText);
		}
		if(opponentHand.isWinner) {
			let textIndex = handNum;// store.tutorialMode ? (handNum * 2) + 1 : handNum + store.activeMatch.roundCount;
			let oldText = m.scoreCardOpponentHands[textIndex];
			let oldNum = parseInt(oldText.text);
			if(oldNum)
				hisCurrentScore = oldNum;
			let x = oldText.x;
			let y = oldText.y;
			oldText.destroy();

			if(opponentHand.finalScore > 0) {
				hisSpot = m.scene.add.sprite(x, y, 'common', purpleSpotToUse);
				m.scoreCardContainer.add(hisSpot);
				hisSpot.setScale((m.oldAssetScaleFactor*1.25));
				hisSpot.setOrigin(0.5, 0.5);
				m.scoreCardElements.push(hisSpot);
			}

			let scoreText = m.scene.add.text(x, y, opponentHand.finalScore > 0 ? opponentHand.finalScore : '-',
				{ fontFamily: m.ui.dodFontFamily,
					fontSize: m.ui.scoreFontSize,
					fill: '#ffffff',
					shadow: { offsetX: 0, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true }
				});
			m.scoreCardContainer.add(scoreText);
			scoreText.setOrigin(0.5, 0.5);
			m.scoreCardElements.push(scoreText);
		}
		if(mySpot != null && sfx && m.ui.scoreDelay > 10) {
			let blueOutLine = m.scene.add.sprite(mySpot.x, mySpot.y, 'common', purpleSpotToUse);
			let scale = m.oldAssetScaleFactor*1.25;
			blueOutLine.setScale(scale);
			blueOutLine.setAlpha(0.5);
			m.scoreCardContainer.add(blueOutLine);
			m.scoreCardElements.push(blueOutLine);
			let evapTween = m.scene.tweens.add({
				targets     : [ blueOutLine ],
				scaleX		: scale * 3,
				scaleY		: scale * 3,
				alpha		: 0.0,
				ease		: 'Linear',
				duration    : 700,
				repeat      : 0
				});
			m.scoreCardTweens.push(evapTween);
		}
		if(hisSpot != null && sfx && m.ui.scoreDelay > 10) {
			let blueOutLine = m.scene.add.sprite(hisSpot.x, hisSpot.y, 'common', purpleSpotToUse);
			let scale = m.oldAssetScaleFactor*1.25;
			blueOutLine.setScale(scale);
			blueOutLine.setAlpha(0.5);
			m.scoreCardContainer.add(blueOutLine);
			m.scoreCardElements.push(blueOutLine);
			let evapTween = m.scene.tweens.add({
				targets     : [ blueOutLine ],
				scaleX		: scale * 3,
				scaleY		: scale * 3,
				alpha		: 0.0,
				ease		: 'Linear',
				duration    : 700,
				repeat      : 0
				});
			m.scoreCardTweens.push(evapTween);
		}
		let myScoreSoFar = m.myLowerBonusScore + m.myUpperBonusScore;
		let hisScoreSoFar = m.opponentLowerBonusScore + m.opponentUpperBonusScore;
		for(let i=0;i <= handNum;i++) {
			myScoreSoFar += (store.activeMatch.hands[i].isWinner ? store.activeMatch.hands[i].finalScore : store.activeMatch.hands[i].score);
			hisScoreSoFar += (store.activeMatch.opponent.hands[i].isWinner ? store.activeMatch.opponent.hands[i].finalScore : store.activeMatch.opponent.hands[i].score);
		}
		m.ui.addToFinalScore(myHand.finalScore-myCurrentScore, opponentHand.finalScore-hisCurrentScore);

		// if(myHand.isWinner || opponentHand.isWinner)
		var tie = (myHand.isWinner && opponentHand.isWinner) || (!myHand.isWinner && !opponentHand.isWinner);
		if(sfx && m.ui.scoreDelay > 10)
			m.playAudio(tie ? 'scoreTie' : myHand.isWinner ? 'scoreWin' : 'scoreLose');
	}

	addToFinalScore(myScore, opponentScore) {
		let myCurrentScore = parseInt(m.finalScoreLeft.text);
		if(!myCurrentScore)
			myCurrentScore = 0;
		let oppCurrentScore = parseInt(m.finalScoreRight.text);
		if(!oppCurrentScore)
			oppCurrentScore = 0;

		myCurrentScore += myScore;
		oppCurrentScore += opponentScore;
		m.finalScoreLeft.text = myCurrentScore;
		m.finalScoreRight.text = oppCurrentScore;
	}
	showFinalScore(myScore, opponentScore, sfx) {
		m.finalScoreLeft.text = myScore;
		m.finalScoreRight.text = opponentScore;

		if(sfx) {// && m.ui.scoreDelay > 10) {
			let targetSize = 102 * m.scaleFactor;
			if(m.myTotalScore !== m.opponentTotalScore) {

				// if(m.myTotalScore > m.opponentTotalScore)
				// 	m.ui.scorecardSliderLeft();
				// else
				// 	m.ui.scorecardSliderRight();

				let y = m.pLeft.y - targetSize * 0.6;
				let centerX = m.myTotalScore > m.opponentTotalScore ? m.pLeft.x : m.pRight.x;
				m.ui.showWinningStars(centerX, y);
			} else {
				if(m.myTotalScore > 0 && m.opponentTotalScore > 0) {
					let y = m.pLeft.y - targetSize * 0.6;
					m.ui.showWinningStars(m.pLeft.x, y);
					m.ui.showWinningStars(m.pRight.x, y);
				}
			}
			// m.playAudio('bigHuzzah');
			if(!store.activeMatch.viewOnlyMode || store.activeMatch.canClaimReward === true)
				m.playAudio('scorescreen_leadin_totalCelebration');
		}
	}
	showWinningStars(centerX, y) {
		var targetSize = 102 * m.scaleFactor;
		if(store.activeMatch.roundCount === 1) {
			targetSize *= 1.3;
			y -= 10 * m.scaleFactor;
		}
		var x = centerX - targetSize/1.8;
		// var yOffsets = [44, 18, 0, 18, 44];
		var yOffsets = [40, 12, 2, 12, 40];
		var xOffsets = [-targetSize*0.5, -targetSize*0.3, 0, targetSize*0.3, targetSize*0.5];
		for(let i=0;i < 5;i++, x += targetSize/3.5) {
			x = centerX + xOffsets[i];
			let lilStar = m.scene.add.sprite(x, y+yOffsets[i]*m.scaleFactor, 'common', 'small_star.png');
			// m.scoreCardHeader.add(lilStar);
			lilStar.setScale(0.42 * m.scaleFactor);
			lilStar.setDepth(6);
			m.ui.scorecardHeaderItems.push(lilStar);
			m.scoreCardElements.push(lilStar);
			let rotTween = m.scene.tweens.add({
				targets     : [ lilStar ],
				angle		: 360,
				ease		: 'Linear',
				duration    : 2000,
				repeat      : -1
				});
			m.scoreCardTweens.push(rotTween);
		}
	}
	showBrownScoreCircle(x, y) {
		let mySpot = m.scene.add.sprite(x, y, 'common', 'scorecardBrownSpot.png');
		m.scoreCardContainer.add(mySpot);
		mySpot.setScale((m.oldAssetScaleFactor*1.1));
		mySpot.setOrigin(0.5, 0.5);
		mySpot.setAlpha(0.18);
		m.scoreCardElements.push(mySpot);
	}
	createStarsContainer(centerX, y, targetSize) {
		var starsContainer = m.scene.add.container(centerX, y);
		starsContainer.setDepth(5);
		// var targetSize = 1.0 * 102;
		var yOffsets = [40, 12, 2, 12, 40];
		var xOffsets = [-targetSize*0.5, -targetSize*0.3, 0, targetSize*0.3, targetSize*0.5];
		for(let i=0;i < 5;i++) {
			let lilStar = m.scene.add.sprite(xOffsets[i] * 1.2, -targetSize*0.7+yOffsets[i]*m.scaleFactor, 'common', 'small_star.png');
			starsContainer.add(lilStar);
			lilStar.setScale(0.42 * m.scaleFactor);
			m.scoreCardElements.push(lilStar);
			let rotTween = m.scene.tweens.add({
				targets     : [ lilStar ],
				angle		: 360,
				ease		: 'Linear',
				duration    : 2000,
				repeat      : -1
			});
			m.scoreCardTweens.push(rotTween);
		}
		m.scoreCardElements.push(starsContainer);
		return(starsContainer);
	}
	tutorialBanner = null;
	showTutorialBanner() {
		if(!m.landscape)
			return;
		if(!m.landscape)
			this.tutorialBanner = m.scene.add.sprite(m.config.width/2, 30*m.scaleFactor, 'tutorialBanner');
		else
			this.tutorialBanner = m.scene.add.sprite(m.pinkHeart.x, m.pinkHeart.y+62*m.scaleFactor, 'tutorialBanner');
		// tutorialBanner.setOrigin(0.45, 0.15);
		this.tutorialBanner.setDepth(4);
		this.tutorialBanner.setScale(0.5 * m.scaleFactor);
		this.tutorialBanner.setAlpha(0.0);
		// m.scoreCardElements.push(this.tutorialBanner);

		m.scene.tweens.add({
			targets     : [ this.tutorialBanner ],
			alpha		: 1.0,
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0
		});
	}
	hideTutorialBanner() {
		if(this.tutorialBanner != null)
			this.tutorialBanner.destroy();
	}
	showWaitingBanner() {
		var waitingBanner;

		// waitingBanner = m.scene.add.sprite(m.config.width/2, m.scoreCardFooter.y - m.scoreCardFooter.height*m.scoreCardFooter.scaleY/3.5, 'language', 'msg_waiting.png');
		// waitingBanner.setScale(m.oldAssetScaleFactor*0.5);
		// // waitingBanner.y = m.config.height - waitingBanner.height/4;
		// waitingBanner.setDepth(5);

		let botName = i18n.t(store.activeMatch.opponent.botKey);
		let text = "Waiting for "+botName+" to Play...";
		var waitingBannerText = m.scene.add.text(m.config.width/2, m.scoreCardFooter.y - m.scoreCardFooter.height*m.scoreCardFooter.scaleY/3.5, text, { fontFamily: m.ui.dodFontFamily, fontStyle: 'italic', fontSize: '50px', fill: '#ffffff', shadow: { offsetX: 2, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true } });
		waitingBannerText.setOrigin(0.5,0.5);
		waitingBannerText.setDepth(5);

		// m.scoreCardElements.push(waitingBanner);
		gameSetTimeout(() => {
			// waitingBanner.destroy();
			waitingBannerText.destroy();
			}, 2000);
	}
	scorecardIsVisible() {
		return(m.scoreCardContainer != null && m.scoreCardContainer.x && m.scoreCardContainer.x > 0);
	}
	showScorecard(handNumber, viewOnly) {
		var match = store.activeMatch;

		var placeHolderHandGoals = [
			'Two Pair',
			'Flush',
			'Straight Flush',
			'Three-of-a-Kind',
			'Full House',
			'Royal Flush',
			'Straight',
			'Four-of-a-Kind',
			'Jackpot!',
		];	

		m.cup.hideCup();
		var single = match.roundCount === 1;

		if(store.tutorialMode) {
			this.killGoalArrow();
		}

		m.ui.hideTutorialBanner();
		m.clearMessages();
		m.diceHand.unlockAllDice();
		m.diceHand.clearDiceOffScreen();

		// clearMessages();
		if(m.handBannerBack)
			m.handBannerBack.destroy();
		if(m.handBanner)
			m.handBanner.destroy();
		if(m.jackPotText)
			m.jackPotText.destroy();
		if(m.handHelp)
			m.handHelp.destroy();
		if(m.skipTutorial)
			m.skipTutorial.destroy();
		if(m.floatingStars)
			m.floatingStars.destroy();


		if(store.oneTurnGame) {
			m.ui.showResults();
			// m.scoreCardElements.push(new OneHandResult(m.scene, match, m));
			return
		}


		m.diceHand.resetDicePriority();

		//TODO: REMOVE FROM SPRITE SHEET
		var dimPanel = m.scene.add.sprite(m.config.width/2, m.config.height/2, 'dimPanel');
		dimPanel.setScale(m.config.width/dimPanel.width, m.config.height/dimPanel.height);
		dimPanel.setDepth(3);
		m.scoreCardElements.push(dimPanel);
		dimPanel.setAlpha(0.0);

		if(m.scoreCardContainer != null)
			m.scoreCardContainer.destroy();
		if(m.scoreCardHeader != null)
			m.scoreCardHeader.destroy();
		// if(m.scoreCardFooter != null)
		// 	m.scoreCardFooter.destroy();
		m.scoreCardContainer = m.scene.add.container(m.config.width/2-m.config.width, m.config.height/2);
		m.scoreCardContainer.setDepth(3);

		var headerBack = null;
		m.scoreCardHeader = m.scene.add.container(m.config.width/2-m.config.width, m.gameHud.hudBackHeight);
		m.scoreCardHeader.setDepth(4);

		//TODO: REMOVE FROM SPRITE SHEET
		headerBack = m.scene.add.image(m.scoreCardHeader.width/2, 0, 'header_scorecard_holes_new');
		headerBack.setOrigin(0.5, 0.0);
		m.scoreCardHeader.add(headerBack);
		headerBack.setScale(m.oldAssetScaleFactor * 0.5);
		m.scoreCardElements.push(headerBack);
		m.scoreCardHeader.headerBackHeight = headerBack.height * headerBack.scaleY;
		m.scoreCardHeader.headerBackWidth = headerBack.width * headerBack.scaleX;

		m.scoreCardHeader.headerSlider = m.scene.add.image(-m.scoreCardHeader.headerBackWidth/4, 0,  'scorecard_header_slider');
		m.scoreCardHeader.headerSlider.setOrigin(0.5, 0.0);
		m.scoreCardHeader.add(m.scoreCardHeader.headerSlider);
		m.scoreCardHeader.headerSlider.setScale(m.oldAssetScaleFactor * 0.5);
		m.scoreCardElements.push(m.scoreCardHeader.headerSlider);

		// gameSetTimeout(m.ui.scorecardSliderSwitchSides, 6000);

		m.scene.tweens.add({
			targets     : [ dimPanel ],
			// x: targetPoint.x,
			// y: targetPoint.y,
			//   ease        : 'Expo.easeIn',
			alpha		: 0.6,
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0,
			completeDelay: 0
		});
		m.scene.tweens.add({
			targets     : [ m.scoreCardContainer ],
			x: m.config.width/2,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0,
				completeDelay: 0
		});
		m.scene.tweens.add({
			targets     : [ m.scoreCardHeader ],
			x: m.config.width/2,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				m.pLeft.setAlpha(1);
				let name = "  "+m.getUsername()+"  ";
				let myName = m.scene.add.text(m.pLeft.x, m.pRight.y+targetSize*0.5, name, { fontFamily: m.ui.dodFontFamily, fontSize: fontSize, fill: '#ffffff', stroke: '#963300', strokeThickness: 3 });
				let plateHeight = (myName.height+2);
				let ret = m.ui.createNameplate(myName.x-myName.displayWidth/2, myName.y-(plateHeight/2), myName.displayWidth, plateHeight, 5, 0xff9226, 1.0, 0x9f5205, 5);
				m.ui.scorecardHeaderItems.push(ret[0]);
				m.ui.scorecardHeaderItems.push(ret[1]);
				m.ui.scorecardHeaderItems.push(myName);

				myName.setOrigin(0.5,0.5);
				myName.setDepth(6);
				m.scoreCardElements.push(myName);
				m.myLevelStar = m.ui.addLevelStar(m.pLeft, targetSize, store.user.level);
				m.ui.scorecardHeaderItems.push(m.myLevelStar);

				m.pRight.setAlpha(1);
				name = match.opponent.name ? match.opponent.name : "Opponent";// match.opponent.name;
				name = '  '+name+'  ';
				let opponentName = m.scene.add.text(m.pRight.x, m.pRight.y+targetSize*0.5, name, { fontFamily: m.ui.dodFontFamily, fontSize: fontSize, fill: '#ffffff', stroke: '#963300', strokeThickness: 3 });
				plateHeight = (opponentName.height+2);
				let ret2 = m.ui.createNameplate(opponentName.x-opponentName.displayWidth/2, opponentName.y-(plateHeight/2), opponentName.displayWidth, plateHeight, 5, 0xff9226, 1.0, 0x9f5205, 5);
				m.ui.scorecardHeaderItems.push(ret2[0]);
				m.ui.scorecardHeaderItems.push(ret2[1]);
				m.ui.scorecardHeaderItems.push(opponentName);
				opponentName.setOrigin(0.5,0.5);
				opponentName.setDepth(6);
				m.scoreCardElements.push(opponentName);
				if(!store.activeMatch.opponent.isBot && store.activeMatch.opponent.level) {
					m.opponentLevelStar = m.ui.addLevelStar(m.pRight, targetSize, store.activeMatch.opponent.level);
					m.ui.scorecardHeaderItems.push(m.opponentLevelStar);
				}

				let topBacking = m.scene.add.image(m.config.width/2, m.gameHud.hudBackHeight+m.scoreCardHeader.headerBackHeight,  'scorecard_backing');
				topBacking.setOrigin(0.5, 0.0);
				topBacking.setDepth(2);
				topBacking.setScale(m.oldAssetScaleFactor * 0.5);
				m.scoreCardElements.push(topBacking);
				m.ui.scorecardHeaderItems.push(topBacking);

				let botomBacking = m.scene.add.image(m.config.width/2, m.scoreCardFooter.y-(m.scoreCardFooter.height*m.scoreCardFooter.scaleY),  'scorecard_backing');
				botomBacking.setOrigin(0.5, 0.8);
				botomBacking.setDepth(2);
				botomBacking.setScale(m.oldAssetScaleFactor * 0.5);
				m.scoreCardElements.push(botomBacking);
				m.ui.scorecardHeaderItems.push(botomBacking);
			}
		});

		var scoreCardX = 0;
		var scoreCardY =  0;
		var pOffset = 150 * m.scaleFactor;
		var portraitLeft = scoreCardX - pOffset;
		var portraitRight = scoreCardX + pOffset;
		var portraitY = m.scoreCardHeader.headerBackHeight * (0.5);

		var targetSize = 0.7 * 102 * 1.1 * m.scaleFactor;
		let fontSize =  '28px';
		let pLeftTargetX = m.config.width/2-pOffset;
		m.pLeft = m.ui.makeProfilePic(pLeftTargetX, m.scoreCardHeader.y+portraitY, targetSize, m.ui.myPortraitName);
		m.pLeft.setAlpha(0);
		m.scoreCardElements.push(m.pLeft);

		let pRightTargetX = m.config.width/2+pOffset;
		m.pRight = m.ui.makeProfilePic(pRightTargetX, m.scoreCardHeader.y+portraitY, targetSize, m.ui.portraitBotName);
		m.pRight.setAlpha(0);
		m.scoreCardElements.push(m.pRight);

		var headerVs = m.scene.add.image(0, m.scoreCardHeader.headerBackHeight * 0.5, 'language', 'msg_vs.png');
		m.scoreCardHeader.add(headerVs);
		headerVs.setScale(m.oldAssetScaleFactor * 0.5 * 0.65 * 0.65);
		m.scoreCardElements.push(headerVs);


		//TODO: Remove from sprite sheet
		let scaleFactorToUse = m.oldAssetScaleFactor * 0.5;
		var scorecard = m.scene.add.sprite(scoreCardX, scoreCardY, '9_hand_scorecard_new').setInteractive();
		m.scoreCardContainer.add(scorecard);
		scorecard.setScale(scaleFactorToUse);
		m.scoreCardElements.push(scorecard);
		m.scoreCardContainer.scorecard = scorecard;
		m.scoreCardContainer.scorecardHeight = scorecard.height * scorecard.scaleX;
		m.scoreCardContainer.scorecardWidth = scorecard.width * scorecard.scaleX;

		m.scoreCardFooter = m.scene.add.image(m.config.width/2-m.config.width, m.config.height+1 * m.scaleFactor, 'language', 'scorecard_footer.png');
		m.scoreCardFooter.setDepth(3);
		m.scoreCardFooter.setOrigin(0.5, 1.0);
		m.scoreCardFooter.setScale(m.oldAssetScaleFactor);
		m.scoreCardElements.push(m.scoreCardFooter);

		m.scene.tweens.add({
			targets     : [ m.scoreCardFooter ],
			x: m.config.width/2,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 200,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				m.scorehelp = m.scene.add.sprite(m.config.width/2+(m.scoreCardContainer.scorecardWidth*0.41), m.scoreCardFooter.y -133 * m.scaleFactor, 'button_help').setInteractive();
				// m.scoreCardContainer.add(scoreHelp);
				m.scorehelp.setDepth(6);
				m.scorehelp.setScale(m.oldAssetScaleFactor/1.5);
				m.scorehelp.homeY = m.scorehelp.y;
				m.scoreCardElements.push(m.scorehelp);
				m.scorehelp.on('pointerdown', function (pointer) {
					this.y += 5;
					m.playAudio("poop");
					this.setFrame(1);
				});
				m.scorehelp.on('pointerup', function (pointer) {
					this.y = this.homeY;
					m.playAudio("pop");
					this.setFrame(0);
					integration.postAnalyticsEvent('scorecard_help', "navigaton");
					store.modal = 'scoring';
					// this.destroy();
				});
				m.scorehelp.on('pointerout', function (pointer) {
					this.y = this.homeY;
				});
			}
		});

		let totalHeight = m.scoreCardHeader.headerBackHeight + m.gameHud.hudBackHeight + m.scoreCardContainer.scorecardHeight + (m.scoreCardFooter.height * m.scoreCardFooter.scaleY);
		if(totalHeight < m.config.height)
			m.scoreCardFooter.y -= (m.config.height - totalHeight);

		m.scoreCardContainer.upperHandsPos = m.scoreCardHeader.headerBackHeight + m.gameHud.hudBackHeight+m.scoreCardContainer.scorecardHeight/2;
		m.scoreCardContainer.lowerHandsPos = (m.scoreCardFooter.y - (m.scoreCardFooter.height * m.scoreCardFooter.scaleX)) - m.scoreCardContainer.scorecardHeight/2;
		m.scoreCardContainer.lowerHandsPos += 4 * m.scaleFactor;
		m.scoreCardContainer.middleHandPos = m.scoreCardContainer.upperHandsPos - m.scoreCardContainer.scorecardHeight * 0.335;
		if(m.scoreCardContainer.middleHandPos <= m.scoreCardContainer.lowerHandsPos)
			m.scoreCardContainer.middleHandPos = m.scoreCardContainer.lowerHandsPos+100*m.scaleFactor;
		if(handNumber < 4)
			m.scoreCardContainer.y = m.scoreCardContainer.lowerHandsPos;
		else if(handNumber < 7)
			m.scoreCardContainer.y = m.scoreCardContainer.middleHandPos;
		else
			m.scoreCardContainer.y = m.scoreCardContainer.upperHandsPos;

		m.finalScoreLeft = m.scene.add.text(scoreCardX-54*m.scaleFactor, m.scoreCardHeader.headerBackHeight*0.5, " ", { fontFamily: m.ui.dodFontFamily, fontSize: '100px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true } });
		m.scoreCardHeader.add(m.finalScoreLeft);
		m.finalScoreLeft.setOrigin(0.5,0.5);
		m.scoreCardElements.push(m.finalScoreLeft);
		m.finalScoreRight = m.scene.add.text(scoreCardX+50*m.scaleFactor, m.scoreCardHeader.headerBackHeight*0.5, " ", { fontFamily: m.ui.dodFontFamily,fontSize: '100px', fill: '#ffffff', shadow: { offsetX: 0, offsetY: 2, color: '#000000', blur: 0, stroke: false, fill: true } });
		m.scoreCardHeader.add(m.finalScoreRight);
		m.finalScoreRight.setOrigin(0.5,0.5);
		m.scoreCardElements.push(m.finalScoreRight);

		var numHands = handNumber <= match.roundCount ? handNumber : match.roundCount;
		var offset = ((scorecard.width*scaleFactorToUse)/2) / 3.5;
		var left = -(((scorecard.width*scaleFactorToUse)/2) - offset);
		var right = scoreCardX + offset;

		var scoreRowDelta = 84 * m.scaleFactor;// m.landscape ? 97 : 88;
		var scoreRowOffsetY = -198 * m.scaleFactor;// (m.landscape && !single) ? 109 : single ? 20 : 82;
		var blueBarOffset = 34 * m.scaleFactor;

		let baseHandNum = handNumber >= 7 ? 7 : handNumber >= 4 ? 4 : 1;
		let showPreviousScores = store.activeMatch.opponent.hands && store.activeMatch.opponent.hands.length && store.activeMatch.opponent.hands.length >= (baseHandNum-1);
		let timeToShowScores = (handNumber === 3 || handNumber === 6 || handNumber >= match.roundCount);
		let showScores = store.activeMatch.opponent.hands && store.activeMatch.opponent.hands.length && store.activeMatch.opponent.hands.length >= handNumber;
		showScores &= timeToShowScores;
		if(store.activeMatch.canClaimReward)
			showScores |= store.activeMatch.canClaimReward;

		var y = (scoreCardY - scoreRowOffsetY);
		y += scoreRowDelta * 2;
		for(let hand=0;hand < match.roundCount;hand++, y -= scoreRowDelta) {
			if(store.activeMatch.roundCount === 9)
				if(hand == 3 || hand == 6)
					y -= blueBarOffset;
			let diceInHand = 5;
			if(hand < numHands) {
				if(hand == match.roundCount-1) {
					let myHand = match.hands[hand];
					var validHand = myHand.match && (myHand.match.length > 2);
					diceInHand = validHand ? myHand.match.length : 0;
				} else {
					let handName = match.goals[hand];
					let index = m.handBannerHandNames.indexOf(handName);
					if(index < 0)
						diceInHand = 5;
					else
						diceInHand = m.dicePerHandType[index];
				}
			}

			m.ui.showScorecardHandTray(diceInHand, left-40 * m.scaleFactor, y+37 * m.scaleFactor, false);

			let oppHandNumber = store.activeMatch.opponent.hands ? store.activeMatch.opponent.hands.length : 0;
			let oppBaseHandNum = oppHandNumber >= 7 ? 7 : oppHandNumber >= 4 ? 4 : 1;
			let useQmark = false;
			if(oppBaseHandNum <= baseHandNum) {
				useQmark = /*showScores && */hand >= (baseHandNum-1) && hand < (baseHandNum + 2);
				useQmark &= store.activeMatch.opponent.hands &&
								store.activeMatch.opponent.hands.length >= baseHandNum &&
								store.activeMatch.opponent.hands.length <= (baseHandNum+2);
			} else {
				useQmark = /*showScores && */hand >= (oppBaseHandNum-1) && hand < (oppBaseHandNum + 2);
			}
			if(hand == match.roundCount-1) {
				diceInHand = 5;
				if(match.opponent.hands && match.opponent.hands[hand]) {
					let oppHand = match.opponent.hands[hand];
					var validHand = oppHand.match && (oppHand.match.length > 2);
					if(validHand === true)
						diceInHand = oppHand.match.length;
				}
			}
			m.ui.showScorecardHandTray(diceInHand, right+20 * m.scaleFactor, y+37 * m.scaleFactor, useQmark);

			m.ui.showBrownScoreCircle(scoreCardX-29 * m.scaleFactor, y+37 * m.scaleFactor);
			m.ui.showBrownScoreCircle(scoreCardX+31 * m.scaleFactor, y+37 * m.scaleFactor);

			var handName;
			if(true) { //hand < numHands) {
				if(hand >= handNumber) {
					let index = hand >= 6 ? (hand - 5) : hand >= 3 ? (hand -2) : hand+1;
					handName = 'Hand'+ index;
				} else {
					handName = match.goals[hand];
					let frame = m.handBannerHandNames.indexOf(handName);
					if(frame <= 0)
						handName = (hand >= store.activeMatch.roundCount-1) ? "Jackpot!" : "";
				}
			} else
				handName = placeHolderHandGoals[hand];

			m.ui.showScorecardHandName( left-53 * m.scaleFactor, y+2 * m.scaleFactor, handName);

			let oppHands = (store.activeMatch.opponent.hands && store.activeMatch.opponent.hands.length && !showPreviousScores && !showScores) ? store.activeMatch.opponent.hands.length : numHands;
			if(true)//hand >= oppHands)
			{
				let bonusTxt = i18n.t("Bonus");
				var scoreText2 = m.scene.add.text(scoreCardX+136 * m.scaleFactor, y+3 * m.scaleFactor, store.activeMatch.rounds[hand].TargetHandPoints+(store.activeMatch.rounds[hand].TargetHandPoints > 1 ? " Pts" : " Pt")+"  +"+store.activeMatch.rounds[hand].TargetHandBonusPoints+" "+bonusTxt,// placeholderHandGoalsBaseScores[hand],
					{ fontFamily: m.ui.dodFontFamily,
						fontSize: '34px',
						fill: '#a56525',
						// stroke: '#8d5a28',
						// strokeThickness: 4
					});
					// scoreText2.setAlpha(0.5);
					m.scoreCardContainer.add(scoreText2);
					m.scoreCardElements.push(scoreText2);
					scoreText2.setOrigin(0.5, 0.5);
			}
		}
		let noDelay = (store.activeMatch.viewOnlyMode || (viewOnly && !store.activeMatch.shouldShowScorecardFirst));
		let scoreDelay = (noDelay && store.activeMatch.canClaimReward !== true) ? 10 : store.tutorialMode ? 750 : (match.roundCount > 1 ? 750 : 750);
		m.ui.scoreDelay = scoreDelay;

		m.finalScoreLeft.text = " ";
		m.finalScoreRight.text = "?";

		//show scores first pass:
		y = (scoreCardY - scoreRowOffsetY);
		if(match.roundCount > 1)
			y += scoreRowDelta * 2;
		for(let hand=0;hand < numHands;hand++, y -= scoreRowDelta) {
			if(store.activeMatch.roundCount === 9)
				if(hand == 3 || hand == 6)
					y -= blueBarOffset;

			let myHand = match.hands[hand];
			let opponentHand = undefined;
			if(match.opponent.hands.length > hand){
				opponentHand = match.opponent.hands[hand];
			}
			if(hand < handNumber-1 || viewOnly || store.activeMatch.canClaimReward === true) {
				m.ui.showScoreCardHand(myHand, hand, scoreCardX-29 * m.scaleFactor, y+37 * m.scaleFactor, left-40 * m.scaleFactor, false, false);
				if(showPreviousScores && hand < baseHandNum-1) {
					m.ui.showScoreCardHand(opponentHand, hand, scoreCardX+31 * m.scaleFactor, y+37 * m.scaleFactor, right+20 * m.scaleFactor, false, true);
					m.ui.showFinalHandScore(hand, false);
				}
			} else {
				gameSetTimeout(m.ui.showScoreCardHand, scoreDelay, myHand, hand, scoreCardX-29 * m.scaleFactor, y+37 * m.scaleFactor, left-40 * m.scaleFactor, true, false);
			}
		}

		//show scores 2nd pass if we have opponent results:
		if(showScores) {
			var extraPause = 0;
			if(match.opponent.isBot === true && !store.activeMatch.viewOnlyMode) {
				gameSetTimeout(m.ui.showWaitingBanner, 1300);
				extraPause += scoreDelay * 1.75;
			}

			let y = (scoreCardY - scoreRowOffsetY);
			y += scoreRowDelta * 2;
			for(let hand=0;hand < numHands;hand++, y -= scoreRowDelta) {
				if(store.activeMatch.roundCount === 9)
					if(hand == 3 || hand == 6)
						y -= blueBarOffset;
				if(hand < baseHandNum-1)
					continue;
				let opponentHand = match.opponent.hands[hand];
				// m.ui.showScoreCardHand(opponentHand, scoreCardX+31, y+37, right+20);
				var h = hand - (baseHandNum - 1);
				let delay = (scoreDelay*2+(h*scoreDelay)+(h+1)*scoreDelay) + extraPause;
				if(h === 0  && !store.activeMatch.viewOnlyMode)
					gameSetTimeout(m.ui.scorecardSliderRight, scoreDelay*3);
				let sfx = !store.activeMatch.viewOnlyMode || store.activeMatch.canClaimReward;
				gameSetTimeout(m.ui.showScoreCardHand, delay, opponentHand, hand, scoreCardX+31 * m.scaleFactor, y+37 * m.scaleFactor, right+20 * m.scaleFactor, sfx, true);
				gameSetTimeout(m.ui.showFinalHandScore, delay + scoreDelay, hand, sfx);
			}
		}

		let buttonDelay = store.tutorialMode ? (scoreDelay * 3) : (scoreDelay);

		//show final score if last hand and we have opponent results:
		if(showScores && handNumber >= match.roundCount) {
			m.myTotalScore = m.myLowerBonusScore + m.myUpperBonusScore;// 0;
			m.opponentTotalScore = m.opponentLowerBonusScore + m.opponentUpperBonusScore;// 0;
			for(let hand=0;hand < match.roundCount;hand++) {
				let myHand = match.hands[hand];
				let myScore = myHand.isWinner ? myHand.finalScore : myHand.score;
				m.myTotalScore += myScore;
				let opponentHand = match.opponent.hands[hand];
				let opponentScore = opponentHand.isWinner ? opponentHand.finalScore : opponentHand.score;
				m.opponentTotalScore += opponentScore;
			}
			let num = match.roundCount === 9 ? 9 : match.roundCount > 1 ? 7 : 4;
			let finalDelay = store.tutorialMode ? (scoreDelay * 4) : (scoreDelay * num) + extraPause;
			gameSetTimeout(m.ui.showFinalScore, finalDelay, m.myTotalScore, m.opponentTotalScore, true);

			buttonDelay += store.tutorialMode ? (scoreDelay) : finalDelay;
		}

		// m.myTotalScore = m.opponentTotalScore + 1;

		buttonDelay += scoreDelay;
		let contDelay = store.activeMatch.viewOnlyMode ? 350 : 0;
		buttonDelay += contDelay;
		if(handNumber != 3 && handNumber != 6 && handNumber < store.activeMatch.roundCount)
			gameSetTimeout(m.ui.showContinueButton, buttonDelay, handNumber, false, viewOnly);
		else
			if(showScores) {
				let nGame = handNumber === 3 && store.tutorialMode ? true : false;
				let del = ((contDelay * 2) + (scoreDelay * ((handNumber-baseHandNum) * 2 + 6))) + extraPause;
				gameSetTimeout(m.ui.showContinueButton, del, handNumber, nGame, viewOnly);

				if(nGame) {
					let targetSize = 102 * m.scaleFactor;
					let y = m.pLeft.y - targetSize * 0.6;
					let centerX = m.pLeft.x;
					gameSetTimeout(m.ui.showWinningStars, del - scoreDelay, centerX, y);
					gameSetTimeout(m.playAudio, del - scoreDelay, 'scorescreen_leadin_totalCelebration');
				}
			} else {
				gameSetTimeout(m.ui.showContinueButton, buttonDelay, handNumber, true, viewOnly);
				// gameSetTimeout(m.ui.showScorecard, 5000, handNumber);
			}

		if(store.tutorialMode) {
			if(handNumber === 1)
				gameSetTimeout(m.ui.createAvaPanel, scoreDelay * 2, m.config.width/2, m.config.height*0.375, "This is the Scorecard!\nYou get points for\nmaking your goals.\n2 more hands to go!", true, 'tutorial_6');
			if(handNumber === 2)
				gameSetTimeout(m.ui.createAvaPanel, scoreDelay * 3, m.config.width/2, m.config.height*0.375, "Every turn has 3 hands –\n1 more to go!", true, 'tutorial_10');
			if(handNumber === 3)
				gameSetTimeout(m.ui.createAvaPanel, scoreDelay * 10, m.config.width/2, m.config.height*0.375, "The higher-ranking hands\ngets Bonus Points!", true, 'tutorial_14');
		} else {
			if(!store.activeMatch.viewOnlyMode && !viewOnly && store.showFirstGameMessages === true && handNumber === 3 && !store.activeMatch.opponent.isBot) {
				gameSetTimeout(m.ui.createAvaPanel, scoreDelay * 3, m.config.width/2, m.config.height*0.375, "Each game has 3 turns.\nSend this turn to your\nopponent, then play\nsomeone else!", true, 'tutorial_15');
				store.showFirstGameMessages = false;
				store.userShownFirstGameMessage();
			}
		}

		m.ui.createScrollingPanel();
		// cheat
			// m.myTotalScore = 10000;
			// gameSetTimeout(m.ui.showResults, 3000);

		integration.postAnalyticsEvent('scorecard_loaded', 'navigation', store.activeMatch.handNumber);
		if(store.activeMatch.viewOnlyMode)
			integration.postAnalyticsEvent(`game_view_lobby_loaded`, `user_experience`);

	}

	createScrollingPanel() {

		const slidingDeceleration = 4000;
		const backDeceleration = false;// 10000;

		let stretch = 50 * m.scaleFactor;

		var x = m.config.width/2,
			y = m.config.height/2,
			w = m.scoreCardContainer.scorecardWidth,
			h = m.scoreCardContainer.scorecardHeight;
		var topY = y - (h / 2),
			leftX = x - (w / 2);
		m.ui.bg = m.scene.add.graphics()
			.setPosition(leftX, topY)
			.fillStyle(0x000033, 1)
			.fillRect(0, 0, w, h)
			.setInteractive(new Phaser.Geom.Rectangle(0, 0, w, h), Phaser.Geom.Rectangle.Contains);
		m.ui.bg.setDepth(4);
		m.ui.bg.setAlpha(0.01);

		let bottomBound = m.scoreCardContainer.lowerHandsPos;
		let topBound = m.scoreCardContainer.upperHandsPos;

		m.ui.scroller = m.scene.plugins.get('rexscrollerplugin').add(m.ui.bg, {
			bounds: [
				bottomBound-stretch,
				topBound+stretch
			],
			value: m.scoreCardContainer.y,
			slidingDeceleration: slidingDeceleration,
			backDeceleration: backDeceleration,
			threshold: 0,
			valuechangeCallback: function(newValue) {
				if(!m.ui.scorecardIsVisible())
					return;
				console.log('topBounds: '+topBound+' botomBound: '+bottomBound+' newValue: '+newValue+' isDragging: '+(m.ui.scroller.isDragging? 'true' : 'false'));
				if(newValue < (topBound + stretch * 2) && newValue > (bottomBound - stretch * 2)) {

					if(m.ui.scrollBounceTimer != null) {
						clearTimeout(m.ui.scrollBounceTimer);
						m.ui.scrollBounceTimer = null;
						if(m.ui.scrollBounceTween != null)
							m.ui.scrollBounceTween.stop();
					}

					// if(newValue < (topBound) && newValue > (bottomBound))
					m.scoreCardContainer.y = newValue;

					if(newValue > topBound)
						m.ui.scrollBounceTimer = gameSetTimeout(m.ui.scrollSnapback, 50, topBound);
					else
						if(newValue < bottomBound)
							m.ui.scrollBounceTimer = gameSetTimeout(m.ui.scrollSnapback, 50, bottomBound);
				}
			}
			// overmaxCallback: function(newValue) {
			// 	if(!m.ui.scorecardIsVisible())
			// 		return;
			// 	m.scoreCardContainer.y = newValue;
			// }
			// overminCallback: function(newValue) {
			// 	if(!m.ui.scorecardIsVisible())
			// 		return;
			// 	m.scoreCardContainer.y = newValue;
			// }
		});
		m.scoreCardElements.push(m.ui.bg);
		m.scoreCardElements.push(m.ui.scroller);

	//         this.scrollerState = this.add.text(0, 0, '');

	//     update() {
	//         this.scrollerState.text = this.scroller.state + "\n" + this.scroller.value;
	//     }
	// }
	}
	scrollBounceTimer = null;
	scrollBounceTween = null;
	scrollSnapback(y) {
		let tween = m.scene.tweens.add({
			targets     : [ m.scoreCardContainer ],
			y: y,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Expo.easeOut',
			duration    : 100,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				m.ui.scroller.value = y;
			},
		});
	}

	scorecardSliderSwitchSides() {
		if(m.scoreCardHeader.headerSlider.x < 0)
			m.ui.scorecardSliderRight();
		else
			m.ui.scorecardSliderLeft();
	}
	scorecardSliderLeft() {
		if(m.scoreCardHeader.headerSlider.x < 0)
			return;
		m.ui.scorecardSlider(-m.scoreCardHeader.headerBackWidth/4)
	}
	scorecardSliderRight() {
		if(m.scoreCardHeader.headerSlider.x > 0)
			return;
		m.ui.scorecardSlider(m.scoreCardHeader.headerBackWidth/4)
	}
	scorecardSlider(targetX) {
		let bounce = targetX < 0 ? -25 * m.scaleFactor : 25 * m.scaleFactor;
		var tween1 = m.scene.tweens.add({
			targets     : [ m.scoreCardHeader.headerSlider ],
			x: targetX+bounce,
			ease		  : 'Linear',
			duration    : 125,
			repeat      : 0,
			callbackScope   : tween1,
			completeDelay: 0,
			onCompleteScope: tween1,
			onComplete: (tween, target ) => {
				var tween2 = m.scene.tweens.add({
					targets     : [ m.scoreCardHeader.headerSlider ],
					x: targetX,
					ease		  : 'Linear',
					duration    : 140,
					repeat      : 0,
					callbackScope   : tween2,
					completeDelay: 0,
					onCompleteScope: tween2,
					onComplete: (tween, target ) => {
						// gameSetTimeout(m.ui.scorecardSliderSwitchSides, 5000);
						},
					});
				},
			});
	}

	defaultButtonHeight = 50*2;

	createButton(image, x, y, width, height, text, pointerUpFunction) {
		let doText = image === 'button_green_wide' || image === 'button_gray_wide' || image === 'button_blue_wide';
		let buttonContainer = m.scene.add.container(x, y);
		buttonContainer.setDepth(4);
		let buttonSprite = null, leftSprite = null, rightSprite = null, wide = false;
		if(doText) {
			let color = image === 'button_green_wide' ? 'green' : image === 'button_gray_wide' ? 'gray' : 'blue';
			let centerImage = 'btn_'+color+'_center.png';
			let leftImage = 'btn_'+color+'_left.png';
			let rightImage = 'btn_'+color+'_right.png';
			image = image + '.png';
			leftSprite = m.scene.add.sprite(0,0, 'language', leftImage).setInteractive();
			leftSprite.setOrigin(1.0, 0.5);
			leftSprite.setScale(m.oldAssetScaleFactor);
			buttonContainer.add(leftSprite);
			rightSprite = m.scene.add.sprite(0,0, 'language', rightImage).setInteractive();
			rightSprite.setOrigin(0.0, 0.5);
			rightSprite.setScale(m.oldAssetScaleFactor);
			buttonContainer.add(rightSprite);

			let endWidth = rightSprite.width * rightSprite.scaleX;
			wide = width > (endWidth*2);
			if(wide)
				width -= (endWidth*2);
			else
				width = endWidth*1.6;

			buttonSprite = m.scene.add.sprite(0,0,'language',  centerImage).setInteractive();
			buttonSprite.setScale(width / buttonSprite.width, m.oldAssetScaleFactor);
			buttonContainer.add(buttonSprite);

			if(wide) {
				let centerWidth = buttonSprite.width*buttonSprite.scaleX;
				leftSprite.x = -centerWidth/2;
				rightSprite.x = centerWidth/2;
			} else
				buttonSprite.setAlpha(0.2);

		} else {
			if(image === 'btn_keep_practicing' || image === 'btn_done_practicing' ||
						image === 'btn_practice' || image === 'btn_take_me' || image === 'btn_play_again' || image === 'btn_get_on_google_play' || image === 'btn_download_appstore')
				buttonSprite = m.scene.add.sprite(0,0, image).setInteractive();
			else
				buttonSprite = m.scene.add.sprite(0,0, 'language', image).setInteractive();
			buttonSprite.setScale(width / buttonSprite.width, width / buttonSprite.width);
			buttonContainer.add(buttonSprite);
		}

		let hitButton = m.scene.add.sprite(0,0, 'language', image).setInteractive();
		let hitWidth = doText ? wide ? (buttonSprite.width * buttonSprite.scaleX + (leftSprite.width*leftSprite.scaleX*2)) : (leftSprite.width*leftSprite.scaleX*2) : width;
		let hitHeight = doText ? (buttonSprite.height * buttonSprite.scaleY) : buttonSprite.height*buttonSprite.scaleY;
		hitWidth *= 1.1;
		hitHeight *= 1.5;

		hitButton.setScale(hitWidth / hitButton.width, hitHeight / hitButton.height);
		buttonContainer.add(hitButton);

		hitButton.debounce = text === 'Skip Tutorial' ? false : true;
		// hitButton.continueButton = text === 'Continue' || text === 'Collect XP' ? true : false;
		hitButton.moveButton = !(image === 'btn_next_game.png' || image === 'btn_rematch_end.png');
		hitButton.buttonPressed = false;
		hitButton.downButtonPressed = false;
		hitButton.oldContainerY = buttonContainer.y;
		hitButton.container = buttonContainer;
		hitButton.setAlpha(0.02);

		hitButton.on('pointerdown', function (pointer) {
			if(this.debounce === true && this.buttonPressed === true || this.downButtonPressed === true)
				return;
			// if(this.continueButton === true)
				this.downButtonPressed = true;

			// this.setTint(0xe0e0e0);
			if(this.moveButton)
				this.container.y += 5;
			m.playAudio("poop");
		});
		hitButton.on('pointerout', function (pointer) {
			if(this.debounce === true && this.buttonPressed === true)
				return;
			if(this.moveButton)
				this.container.y = this.oldContainerY;
			this.buttonPressed = false;
		});
		hitButton.on('pointerup', function (pointer) {
			if(this.debounce === true && this.buttonPressed === true)
				return;
			this.buttonPressed = true;

			// this.clearTint();
			if(this.moveButton)
				this.container.y = this.oldContainerY;
			m.playAudio("pop");
			gameSetTimeout(pointerUpFunction, 150);
			// pointerUpFunction();
		});
		if(doText) {
			let fontSize = (text === m.ui.extraRollButtonText || text === 'Skip Tutorial') ? '28px' : text === '     Restart Hand' ? '23px' : text === 'Accept' ? '48px' : '32px';
			var buttonText = m.scene.add.text(0,-2.5 * m.scaleFactor, text, { fontFamily: m.ui.dodFontFamily, fontSize: fontSize, fill: '#ffffff', stroke: '#0', strokeThickness: 4 });
			buttonText.setOrigin(0.5,0.5);
			buttonContainer.add(buttonText);
		}
		return buttonContainer;
	}

	continueButtonHasBeenPressed = false;

	showContinueButton(handNumber, nextGame, viewOnly) {
		m.ui.scorecardSliderLeft();

		if(!nextGame && store.activeMatch.userState !== 'pl' && handNumber < store.activeMatch.roundCount)// !store.activeMatch.canRollDice)
			nextGame = true;

		var yMod = 0.97;// 0.75;

		let x = m.config.width*0.5;
		let y = m.scoreCardFooter.y - 50 * m.scaleFactor;
		let buttonText = (nextGame && !store.activeMatch.viewOnlyMode && !store.tutorialMode) ? 'Send Turn' : (handNumber >= store.activeMatch.roundCount && (!store.activeMatch.viewOnlyMode || store.activeMatch.canClaimReward === true)) ? 'Collect XP' : store.activeMatch.viewOnlyMode ? 'Back' : 'Continue';
		let buttonType = buttonText === 'Send Turn' ? 'btn_send_turn.png' :
						buttonText === 'Collect XP' ? 'btn_collect_xp.png' :
						buttonText === 'Back' ? 'btn_back.png' : 'btn_skip_hand.png';

		let buttonWidth = buttonText === 'Collect XP' ? m.adjustX(480)*0.4 : m.adjustX(480)*0.4;
		m.ui.continueButtonHasBeenPressed = false;

		m.ui.continueButtonContainer = m.ui.createButton(buttonType, x, y, buttonWidth, m.ui.defaultButtonHeight, buttonText,  async function (pointer) {
			if(m.ui.continueButtonHasBeenPressed) {
				console.log("TRIED TO PRESS CONTINUE AGAIN");
				return;
			}
			m.ui.continueButtonHasBeenPressed = true;

			m.ui.scroller.destroy();
			m.ui.bg.destroy();

			store.tutorialState = '';
			m.ui.clearAvaPanel();

			integration.postAnalyticsEvent('scorecard_continue', store.tutorialMode ? 'tutorial' : 'navigation', store.activeMatch.handNumber);

			if(!store.tutorialMode && (handNumber === 3 || handNumber === 6 || handNumber === store.activeMatch.roundCount)) {
				store.turnsThisSession++;
				store.turnsSinceLastAdView++;
			}

			if(buttonText === 'Send Turn' && !store.tutorialMode)
				integration.postAnalyticsEvent('send_turn_'+store.activeMatch.handNumber, 'navigation', store.activeMatch.handNumber);

			if(nextGame && !store.tutorialMode) {
				store.getLobbyData().then(() => {
					history.push('/');
				})

				if(buttonText === 'Back')
					return;

				return;
			}

			if(nextGame && store.tutorialMode) {
				m.ui.endOfTutorialSequence();
				return;
			}

			let weClaimIn = store.activeMatch.canClaimReward === true; //store.canClainm will be cleared afer claimReward() below
			if(buttonText === 'Collect XP') {
				integration.postAnalyticsEvent(`reward_post_game_collect_xp`, 'economy', store.user.animateToXp-store.user.xp);
				if(store.activeMatch.canClaimReward === true)
					await store.activeMatch.claimReward();
			}

			if(handNumber >= store.activeMatch.roundCount) {
				m.ui.fadeScorecard();
				if(!viewOnly || weClaimIn === true)
					m.ui.showResults();
				else {
					store.getLobbyData().then(() => {
						history.push('/');
					})
					return;
				}
			} else {
				if(store.tutorialMode && store.activeMatch.handNumber === 2)
					m.ui.showContinuePractice();
				else
					m.ui.slideOffScorecard(handNumber, viewOnly);
			}
			// m.ui.continueButtonContainer.destroy();
			m.ui.continueButtonContainer.setAlpha(0);
		});

		if(store.tutorialMode && (store.activeMatch.handNumber === 2 || store.activeMatch.handNumber === 3 || store.activeMatch.handNumber === 4))
			m.ui.makePulsate(m.ui.continueButtonContainer);

		m.scoreCardElements.push(m.ui.continueButtonContainer);
	}

	scorecardHeaderItems = [];
	clearScorecardHeaderItems() {
		m.ui.scorecardHeaderItems.forEach(el => el.setAlpha(0));
		m.ui.scorecardHeaderItems = [];
	}

	fadeScorecard() {
		m.pLeft.setAlpha(0);
		m.pRight.setAlpha(0);
		m.ui.clearScorecardHeaderItems();
		m.scorehelp.setAlpha(0);
		m.scene.tweens.add({
			targets     : [ m.scoreCardContainer, m.scoreCardHeader, m.scoreCardFooter ],
			alpha: 0,
			ease		  : 'Linear',
			duration    : 350,// 300,
			repeat      : 0,
			completeDelay: 0
		});
	}
	continueButtonContainer = null;
	newGameContainer = null;
	nextGameButton = null;
	mainMenuButton = null;
	extraRollButtonText = "     Extra Roll";
	downloadNow = null;
	showNextGameButton = () => {
		var startYOffset = 50;
		var newGameButtonY = m.adjustY(852) * ( 0.7) - 30 * m.scaleFactor;
		let x = m.config.width/2;
		let y = newGameButtonY+startYOffset;

		if(store.oneTurnGame) {
			this.newGameContainer = this.createButton('btn_play_again', x, y, (m.adjustX(480)/2), (this.defaultButtonHeight*1.5), "Rematch", function (pointer) {
				console.log("button play again BUTTON POINTERUP");

				// m.ui.showResults();
				// return;

				store.createMatch(store.getRandomBotId())
				.then(response => {
					history.push(`/game/${response.Match.Id}/play`);
				})

				// m.ui.rematch();
			});

				m.ui.downloadNow = m.scene.add.sprite(m.config.width/2, m.config.height-320, 'msg_1_turn_download_now');
				m.ui.downloadNow.setDepth(3);
				m.ui.downloadNow.setScale(0.5*2);
				m.scoreCardElements.push(m.ui.downloadNow);

				gameSetTimeout(m.ui.makePulsate, 4500, m.ui.downloadNow);

				let googlebutton = this.createButton('btn_get_on_google_play', m.config.width*0.27, m.config.height - 160, (m.config.width * 0.45), (this.defaultButtonHeight*1.5), "Next Game", function (pointer) {
					var url = m.storeLink;
					var s = window.open(url, '_blank');
					if (s && s.focus)
						s.focus();
					else if (!s)
						window.location.href = url;
				});
				let appleButton = this.createButton('btn_download_appstore', m.config.width*0.73, m.config.height - 160, (m.config.width * 0.45), (this.defaultButtonHeight*1.5), "Next Game", function (pointer) {
					var url = m.storeLink;
					var s = window.open(url, '_blank');
					if (s && s.focus)
						s.focus();
					else if (!s)
						window.location.href = url;
				});

			return;
		}

		store.forceGetNotifications();

		var promise = Promise.resolve();

		promise.then(() => {
			store.activeMatch.userHasSeenResolution = true;
			integration.onMatchEnd();
			m.matchesThisSession++;

				this.newGameContainer = this.createButton('btn_rematch_end.png', x, y+m.config.height/2, (m.adjustX(480)/2), (this.defaultButtonHeight*1.5), "Rematch", function (pointer) {
					console.log("rematch BUTTON POINTERUP");

					// m.ui.newGameContainer.destroy();
					let val = m.myTotalScore > m.opponentTotalScore ? 1 : m.myTotalScore < m.opponentTotalScore ? 0 : 2;
					integration.postAnalyticsEvent(`post_game_rematch`, `gameplay`, val);

					m.ui.rematch();
				});

			var mainMenuButtonY = m.adjustY(852) * ( 0.825) - 40 * m.scaleFactor;
			var startXOffset = 0;

			this.nextGameButton = this.createButton('btn_next_game.png', this.newGameContainer.x-startXOffset, mainMenuButtonY+startYOffset+m.config.height/2, (m.adjustX(480)/2), (this.defaultButtonHeight*1.5), "Next Game", function (pointer) {
				integration.postAnalyticsEvent(`next_game_post_game`, 'navigation', store.user.level);
				// m.ui.newGameContainer.destroy();
				// this.destroy();
				store.getLobbyData().then(() => {
				history.push('/');
				})
			});
			if(store.oneTurnGame)
				this.nextGameButton.setAlpha(0);

			m.scoreCardElements.push(this.nextGameButton);
			// m.scoreCardElements.push(this.newGameContainer);

			// m.playAudio("Transitions_Movement");

				m.scene.tweens.add({
					targets     : [ this.newGameContainer ],
					y: y,
					//   ease        : 'Expo.easeIn',
					ease		  : 'Linear',
					duration    : 350,
					repeat      : 0
				});

				m.scene.tweens.add({
					targets     : [ this.nextGameButton ],
					y: mainMenuButtonY,
					//   ease        : 'Expo.easeIn',
					ease		  : 'Linear',
					duration    : 350,
					repeat      : 0
				});
		}); // end promise

	}

	slideOffScorecard(handNumber, viewOnly) {
		m.pLeft.setAlpha(0);
		m.pRight.setAlpha(0);
		m.ui.clearScorecardHeaderItems();

		m.scene.tweens.add({
			targets     : [ m.scoreCardContainer ],
			x: m.scoreCardContainer.x-m.config.width,
			ease		  : 'Linear',
			duration    : 300,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				if(!viewOnly) {
					if(handNumber >= store.activeMatch.roundCount) {
						m.ui.showResults();
					} else {
						m.ui.showRoundBanner();
						m.addCurrentHandObserver();
						m.updateInfo();
					}
				} else {
					if(store.activeMatch.viewOnlyMode) {
						store.getLobbyData().then(() => {
							history.push('/');
						});
						// m.ui.rematch();
						return;
					} else
						m.ui.showRoundBanner();
				}
			}
		});
		var headerTween = m.scene.tweens.add({
			targets     : [ m.scoreCardHeader ],
			x: m.scoreCardHeader.x - m.config.width,
			ease		  : 'Linear',
			duration    : 300,
			repeat      : 0,
			callbackScope   : headerTween,
				completeDelay: 0,
				onComplete: (tween, target ) => {
				},
				onCompleteScope: headerTween,
			});
		m.scorehelp.setAlpha(0);
		var footerTween = m.scene.tweens.add({
			targets     : [ m.scoreCardFooter ],
			x: m.scoreCardFooter.x - m.config.width,
			ease		  : 'Linear',
			duration    : 300,
			repeat      : 0,
			callbackScope   : footerTween,
			completeDelay: 0,
			onComplete: (tween, target ) => {
				},
			onCompleteScope: footerTween,
			});
	}

	showZoomer(diceNum) {
		if(m.zoomerContainer != null) {
			m.zoomerContainer.destroy();
			m.zoomerContainer = null;
		}
		var diceObjects = m.diceHand.dice;
		var d = diceObjects[diceNum];
		m.zoomerContainer = m.scene.add.container(d.homePosition.x, d.homePosition.y);
		m.zoomerContainer.setDepth(3);
		var scale = m.oldAssetScaleFactor;

		var zoomerBack = m.scene.add.sprite(0, 0, 'zoomer');
		zoomerBack.setScale(scale);
		zoomerBack.setFrame(1);
		m.scoreCardElements.push(zoomerBack);
		m.zoomerContainer.add(zoomerBack);

		var targetSize = 50 * m.scaleFactor;
		var tinyX = -targetSize/2;
		var tinyY = -(targetSize*2)/2;
		tinyY -= 2;
		for(let i=0;i < 6;i++) {
			var tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'dice2D_sheet');
			var num = ((diceNum*6)+i);
			tinyDice1.setFrame(num);
			m.scoreCardElements.push(tinyDice1);
			tinyDice1.setScale(targetSize/tinyDice1.width);
			m.zoomerContainer.add(tinyDice1);
			tinyX += targetSize;
			if(tinyX > targetSize/2) {
				tinyX = -targetSize/2;
				tinyY += targetSize;
			}
		}

		var mask = m.scene.make.sprite({ x: zoomerBack.x, y: zoomerBack.y, key: 'zoomer', add: false });
		mask.setScale(scale);
		mask.setFrame(1);
		// zoomerContainer.mask = new Phaser.Display.Masks.BitmapMask(m.scene, mask);

		var ring = m.scene.add.sprite(0, 0, 'zoomer');
		ring.setScale(scale);
		// ring.setFrame(0);
		m.scoreCardElements.push(ring);
		m.zoomerContainer.add(ring);

		m.lastZoomedDice = diceNum;
	}
	zoomZoomer(y) {
		if(m.lastZoomerTween != null)
			m.lastZoomerTween.stop();
			m.lastZoomerTween = m.scene.tweens.add({
			targets	: [ m.zoomerContainer ],
			y			: y,
			scaleX	: 1.3,
			scaleY	: 1.3,
			ease		: 'Linear',
			duration	: 130,
			repeat	: 0,
		});
	}
	unZoomZoomer(y) {
		if(m.lastZoomerTween != null)
			m.lastZoomerTween.stop();
		m.lastZoomerTween = m.scene.tweens.add({
			targets     : [ m.zoomerContainer ],
			y: y,
			scaleX: 1.0,
			scaleY: 1.0,
			ease        : 'Linear',
			duration    : 130,
			repeat      : 0,
		});
	}
	zoomButton = null;
	showZoomButton() {
		var offset = 0;

		m.ui.zoomButton2 = m.scene.add.sprite(33*m.scaleFactor, m.handBannerPosition+offset, 'button_zoom').setInteractive();
		m.ui.zoomButton2.setScale(m.oldAssetScaleFactor);
		m.ui.zoomButton2.setDepth(3);
		m.ui.zoomButton2.setFrame(1);
		m.ui.zoomButton2.homeX = m.ui.zoomButton2.x;
		m.ui.zoomButton2.homeY = m.ui.zoomButton2.y;
		m.ui.zoomButton2.on('pointerdown', function (pointer) {
			this.y += 5;
			m.playAudio("poop");
		});
		m.ui.zoomButton2.on('pointerup', function (pointer) {
			m.ui.doZoomButtonUp();
		});
		m.scoreCardElements.push(m.ui.zoomButton2);
		m.ui.zoomButton2.setAlpha(0);


		m.ui.zoomButton = m.scene.add.sprite(33*m.scaleFactor, m.handBannerPosition+offset, 'button_zoom').setInteractive();
		m.ui.zoomButton.setScale(m.oldAssetScaleFactor);
		m.ui.zoomButton.setDepth(3);
		m.ui.zoomButton.homeX = m.ui.zoomButton.x;
		m.ui.zoomButton.homeY = m.ui.zoomButton.y;
		m.ui.zoomButton.on('pointerdown', function (pointer) {
			this.y += 5;

			if(m.zoomerContainer != null)
				m.ui.doZoomButtonUp();
			else
			m.playAudio("poop");
		});
		m.ui.zoomButton.on('pointerout', function (pointer) {
			if(m.zoomerContainer == null)
				m.ui.zoomButton.y = this.homeY;
		});
		m.ui.zoomButton.on('pointerup', function (pointer) {
			m.ui.doZoomButtonUp();
		});
		m.scoreCardElements.push(m.ui.zoomButton);

	}
	doZoomButtonUp() {
		m.ui.zoomButton.y = m.ui.zoomButton.homeY;
		m.ui.zoomButton2.y = m.ui.zoomButton2.homeY;
		if(store.tutorialMode && store.tutorialState === 'handInfo'){
			store.tutorialState = '';
			store.tutorialPreventRoll = false;
			store.m.cup.reallyReturnCup(true);
		}
		m.playAudio("pop");

		if(m.zoomerContainer == null) {
			m.ui.showZoomer(4);
			m.ui.zoomButton.setFrame(1);
			m.cup.hideCup();
			if(m.ui.selectDiceMsg != null) {
				m.ui.selectDiceMsg.setFrame(1);
				m.ui.selectDiceMsg.y += 30;
			}
			m.ui.zoomButton.x = m.ui.selectDiceMsg.x - (m.ui.selectDiceMsg.width * m.ui.selectDiceMsg.scaleX) * 0.45;
			m.ui.zoomButton.y = m.ui.selectDiceMsg.y;
			m.ui.zoomButton2.setAlpha(1);
		} else {
			m.zoomerContainer.destroy();
			m.zoomerContainer = null;
			if(m.ui.selectDiceMsg != null) {
				m.ui.selectDiceMsg.destroy();
				m.ui.showSelectDiceMsg();
			}
			m.ui.zoomButton.setFrame(0);
			m.ui.zoomButton.x = m.ui.zoomButton.homeX;
			m.ui.zoomButton.y = m.ui.zoomButton.homeY;
			m.ui.zoomButton2.setAlpha(0);
			m.cup.reallyFakeReturnCup(true);
		}
	}

	selectDiceMsg = null;

	showSelectDiceMsg() {
		var diceObjects = m.diceHand.dice;
		var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth * 1.85;
		m.ui.selectDiceMsg = m.scene.add.sprite(m.config.width/2, yPos, 'selectDice');
		m.ui.selectDiceMsg.setScale(m.oldAssetScaleFactor);
		m.scoreCardElements.push(m.ui.selectDiceMsg);
		if(store.tutorialMode)
			m.ui.selectDiceMsg.setAlpha(0);
	}

	endOfShortTutorial() {
		var diceObjects = m.diceHand.dice;
		var epicYPos = diceObjects[5].defaultHomePosition.y - m.diceActualWidth * 0.7;
		let epicBanner = m.scene.add.sprite(m.config.width/2, epicYPos - m.config.height/2, 'short_tutorial_banner_epic');
		epicBanner.setScale(m.oldAssetScaleFactor*0.7);
		epicBanner.setDepth(2);
		m.playAudio('epic_win');
		m.scene.tweens.add({
			targets     : [ epicBanner ],
			y			: epicYPos+30,
			ease		: 'Linear',
			duration    : 300, repeat      : 0,
			delay		: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				m.scene.tweens.add({
					targets     : [ epicBanner ],
					y			: epicYPos,
					ease		: 'Linear',
					duration    : 50, repeat      : 0,
					delay		: 0,
					completeDelay: 0,
					onComplete: (tween, target) => {
						integration.postAnalyticsEvent(`ftue_post_roll`, 'ftue');
						integration.postAnalyticsEvent(`tutorial_menu`, `tutorial_ftue`);

						var diceObjects = m.diceHand.dice;
						var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth *  1.75;
						let resultsBanner = m.scene.add.sprite(0, 0, 'short_tutorial_box_easy_to_win');
						resultsBanner.setScale(m.oldAssetScaleFactor);
						yPos += (resultsBanner.height*resultsBanner.scaleY)*0.4;
						let bannerContainer = m.scene.add.container(m.config.width/2, yPos + m.config.height);
						bannerContainer.add(resultsBanner);
						bannerContainer.setDepth(0);
						let practice = m.ui.createButton('btn_practice', 0, m.adjustY(-5), 300*m.scaleFactor, (this.defaultButtonHeight*1.5), "KEEP PRACTICING", function (pointer) {
							console.log("pressed keep practicing button");
							resultsBanner.destroy();
							bannerContainer.destroy();
							epicBanner.destroy();

							store.tutorialMode = true;
							store.preventReturnToSplash = true;
							integration.postAnalyticsEvent(`ok_tutorial`, `tutorial_ftue`);
							integration.postAnalyticsEvent('tutorial_start', 'tutorial');
							window.WrapperApp.postMessage("tutorial-start?success=true");
							history.push(`/game/tutorial/play`);
						});
						m.ui.makePulsate(practice);
						bannerContainer.add(practice);

						let takeMeToGame = m.ui.createButton('btn_take_me', 0, m.adjustY(80), 300*m.scaleFactor, (this.defaultButtonHeight*1.5), "KEEP PRACTICING", function (pointer) {
							console.log("pressed done practicing button");
							integration.postAnalyticsEvent(`skip_tutorial`, `tutorial_ftue`);
							resultsBanner.destroy();
							bannerContainer.destroy();
							epicBanner.destroy();
							history.push('/tutorial-skip-confirm');
						});
						bannerContainer.add(takeMeToGame);

						m.scene.tweens.add({
							targets     : [ bannerContainer ],
							y			: yPos,
							ease		: 'Linear',
							duration    : 300, repeat      : 0,
							delay		: 0,
							completeDelay: 0,
							onComplete: (tween, target) => {
							}
						});
					}
				});
			}
		});

	}

	showBigWinBanner = () => {
		var diceObjects = m.diceHand.dice;
		var handName = store.activeMatch.matchId === 'intro' ? 'royal-flush' : store.activeMatch.goals[store.activeMatch.handNumber-1];
		if(!handName || handName == null || handName == undefined && (typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
			handName = store.activeMatch.currentHand.bestHandTargetString;
		var frame = store.activeMatch.currentHand.best ? 0 : m.handBannerHandNames.indexOf(handName);
		let jackpot = (frame < 0 && store.activeMatch.handNumber >= store.activeMatch.roundCount);

		if(store.activeMatch.currentHand.isWinningHand || jackpot) {
			if(store.tutorialMode)
				m.ui.killGoalArrow();
			if(store.activeMatch.currentHand.isWinningHand) {
				m.diceHand.unlockAllDice();
				store.activeMatch.currentHand.match.forEach((d)=>{
					diceObjects[d].addFlair('flair');
					diceObjects[d].locked = true;
				});
				m.diceHand.darkenUnlockedDice();
			}
			if(frame >= 0 || jackpot) {
				// var count = store.activeMatch.currentHand.match.length;
				// var stageWidth = m.diceActualWidth * (m.landscape ? 4.5 : 4);// m.config.width * 0.9;
				// var diceWidth = (stageWidth) / count;
				// var minWidth = (stageWidth) / 5;
				// var adjust = diceWidth / m.diceActualWidth;
				// var scaleToUse = m.diceBigScale * adjust;
				var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth * 1.825;// 1.75;
				if(frame >= 0){
					var bigWinBack = m.scene.add.sprite(m.config.width/2, yPos, 'common', 'big_win_banner.png');
				}else{
					var bigWinBack = m.scene.add.sprite(m.config.width/2, yPos, 'language', 'big_win_two_pair_or_better.png');
				}

				bigWinBack.setScale(m.oldAssetScaleFactor);
				bigWinBack.setDepth(1);
				m.scoreCardElements.push(bigWinBack);

				if(frame >= 0) {
					var bigWinBanner = m.scene.add.sprite(m.config.width/2, yPos-5, 'bigWinPanel');
					bigWinBanner.setScale(m.oldAssetScaleFactor);
					bigWinBanner.setDepth(1);
					bigWinBanner.setFrame(frame);
					m.scoreCardElements.push(bigWinBanner);

					m.floatingStars = m.scene.add.sprite(bigWinBack.x, bigWinBack.y, 'floatingStars001');
					m.floatingStars.setScale(1.0);
					m.floatingStars.setDepth(3);
					m.floatingStars.anims.play('floatingStars');
					m.scoreCardElements.push(m.floatingStars);
				}
			}

			m.playAudio(store.activeMatch.currentHand.best ? 'winnerV3' : 'twinkle');

			if(store.oneTurnGame || store.activeMatch.currentHand.best || (store.tutorialMode && store.activeMatch.matchId === 'intro'))
				m.diceHand.resolveGridToHorizontal();

			// gameSetTimeout(m.diceHand.resolveGridFromHorizontal, 3000);
		} else {
			if(!store.activeMatch.currentHand.isWinningHand && !store.tutorialMode) {
				m.ui.showNoHandBanner();
			}
		}
	};

	showNoHandBanner = () => {
		var yPos = m.diceHand.dice[5].defaultHomePosition.y + m.diceActualWidth * 1.825; // 1.75;
		var bigWinBack = m.scene.add.sprite(m.config.width / 2, yPos, 'common', 'big_win_banner.png');
		bigWinBack.setScale(m.oldAssetScaleFactor);
		bigWinBack.setDepth(1);
		m.scoreCardElements.push(bigWinBack);
		if(store.pokerRush)
			return;
			
		var bigWinBanner = m.scene.add.sprite(
			m.config.width * 0.5,
			yPos-4,
			'bigWinPanel'
		);
		bigWinBanner.setScale(m.oldAssetScaleFactor);
		bigWinBanner.setDepth(1);
		bigWinBanner.setFrame(9);
		m.scoreCardElements.push(bigWinBanner);
	}

	playHandButtonPressed = false;
	extraRollButtonPressed = false;
	playHandButtonType = null;
	playHandButtonText = null;
	buttonPinkHeart = null;
	buttonPinkHeartText = null;
	button2 = null;

	animatePinkHeart = (hearts) => {
		let scaleToUse = m.oldAssetScaleFactor* 0.8;
		var heart;
		// heart = m.scene.add.sprite(m.gameHud.x+m.adjustX(146), m.gameHud.y+m.gameHud.hudBackHeight/2-1*m.scaleFactor, 'common', 'pinkHeart.png');
		if(hearts === 5)
			heart = m.scene.add.sprite(m.gameHud.x+m.adjustX(146), m.gameHud.y+m.gameHud.hudBackHeight/2-1*m.scaleFactor, 'pinkHeart_5');
		else
			heart = m.scene.add.sprite(m.gameHud.x+m.adjustX(146), m.gameHud.y+m.gameHud.hudBackHeight/2-1*m.scaleFactor, 'pinkHeart_1');
		heart.setScale(scaleToUse, scaleToUse);
		heart.setDepth(6);
		m.scoreCardElements.push(heart);

		m.scene.tweens.add({
			targets     : [ heart ],
			x: m.ui.button2.x+m.ui.buttonPinkHeart.x,
			y: m.ui.button2.y+m.ui.buttonPinkHeart.y,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 300,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				m.ui.buttonPinkHeartText.text = "";
				heart.setScale(scaleToUse*2, scaleToUse*2);
				heart.setAlpha(0.5);
				m.scene.tweens.add({
					targets     : [ heart ],
					scaleX		: scaleToUse,
					scaleY		: scaleToUse,
					alpha		: 1,
					//   ease        : 'Expo.easeIn',
					ease		  : 'Linear',
					duration    : 300,
					repeat      : 0,
					// completeDelay: 0,
					// onComplete: (tween, target) => {
					// 	this.animateGoalArrow();
					// }
				});
			}
		});
	}

	finishExtraRoll = () => {
		m.clearMessages();
		if(store.activeMatch.currentHand.isWinningHand) {
			m.diceHand.resumeFromHeart();
		}
		m.cup.returnCup();
	}
	finishHandReset = () => {
		m.clearMessages();
		m.diceHand.unlockAllDice();
		m.diceHand.clearDiceOffScreen();
		store.activeMatch.currentHand.rollNumber = 0;
		// if(store.activeMatch.currentHand.isWinningHand) {
		// 	m.diceHand.resumeFromHeart();
		// }
		m.cup.returnCup();
	}

	showPlayHandButton = () => {
		let yMod = 0.72;
		let xMod = 4;
		let tutPlayOnly = false;
		let shouldPulse = false;
		let isEligibleForRewardRoll = store.isEligibleForRewardRoll;

		if(store.tutorialMode){
			if(store.activeMatch.handNumber < 3){
				if(store.activeMatch.handNumber === 1) {
					yMod = 0.9;
					m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos+68*m.scaleFactor, "You got it!", true, 'tutorial_5');
					shouldPulse = true;
					m.skipTutorial.setAlpha(0);
				} else
					if(store.activeMatch.handNumber === 2) {
						if(store.activeMatch.currentHand.rollNumber === 3) {
							yMod = 0.83;
							m.ui.createAvaPanel(m.config.width/2, m.adjustY(852)*m.ui.avaPanelPos, "Didn’t achieve the goal?\nUse an Extra Roll!", true, 'tutorial_9');
						} else
							shouldPulse = true;
					}
			} else
				if(store.activeMatch.handNumber === 3) {
					shouldPulse = true;
					m.ui.createAvaPanel(m.config.width/2, m.config.height*0.275, "Nice! You got the BEST Straight.\nNo need to take your 3rd roll...\ncan’t do any better!", true, 'tutorial_12');
				}

			tutPlayOnly = (store.activeMatch.handNumber === 1) || (store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 4);
			if(tutPlayOnly){
				xMod = 2;
			}
			if(store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 3){
				store.tutorialState = 'noflush';
			}
			if(store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 4){
				store.tutorialState = 'freerollworked';
			}
		}

		var bOffset = !tutPlayOnly ? m.defaultButtonWidth * 2.5 : m.defaultButtonWidth;
		var bx = 240 * 2 - ((960) / xMod + 10);
		bx = m.config.width / 2 - bx;
		if(store.activeMatch.currentHand.best || store.oneTurnGame)
			bx = m.config.width/2;

		let playOrSkip = !store.canUseExtraRoll && store.canUseHandReset && !store.activeMatch.currentHand.isWinningHand ? false :
							isEligibleForRewardRoll && !store.activeMatch.currentHand.isWinningHand ? false : store.playOrSkip;
		// m.ui.playHandButtonType = playOrSkip ? 'button_blue_wide' : 'button_gray_wide';
		m.ui.playHandButtonType = playOrSkip ? 'btn_play_hand.png' : 'btn_skip_hand.png';
		m.ui.playHandButtonText = playOrSkip ? "Play Hand" : "Skip Hand";

		//4th roll miss button should say 'continue':
		if(!store.activeMatch.currentHand.isWinningHand && store.activeMatch.currentHand.rollNumber > 3)
			m.ui.playHandButtonType = 'btn_skip_hand.png';

		if(!store.tutorialMode && (!playOrSkip && store.activeMatch.handNumber < store.activeMatch.roundCount))
			yMod = 0.66;


		if(isEligibleForRewardRoll && !store.oneTurnGame) {
			//winning hand but needs 2 pair or better; push down watch video banner if needed:
			var need2PairOrBetter = false;
			var hName = store.activeMatch.goals[store.activeMatch.handNumber-1];
			if(!hName || hName == null || hName == undefined && (typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
				hName = store.activeMatch.currentHand.bestHandTargetString;
			var frame = store.activeMatch.currentHand.best ? 0 : m.handBannerHandNames.indexOf(hName);
			let jackpot = (frame < 0 && store.activeMatch.handNumber >= store.activeMatch.roundCount);
			if(store.activeMatch.currentHand.isWinningHand || jackpot) {
				if(frame < 0 && jackpot)
					need2PairOrBetter = true;
			}

			yMod = store.activeMatch.currentHand.isWinningHand || need2PairOrBetter ? 0.89 : 0.82;
		}

		m.ui.playHandButtonPressed = false;
		m.ui.extraRollButtonPressed = false;
		var button = m.ui.createButton(m.ui.playHandButtonType, bx, m.adjustY(852) * yMod, (960)*((store.activeMatch.currentHand.best || store.oneTurnGame) ? 0.5 : 0.4), m.ui.defaultButtonHeight*((store.activeMatch.currentHand.best || store.oneTurnGame) ? 1.35 : 1.25), m.ui.playHandButtonText, function (pointer) {
			console.log("pressing play/skip...");

			if(store.tutorialMode && store.activeMatch.handNumber === 2 && m.ui.playHandButtonText === 'Skip Hand')
				return;

			if(m.ui.playHandButtonPressed === true || m.ui.extraRollButtonPressed === true) {
				console.log("play/skip already pressed");
				return;
			}
			m.ui.playHandButtonPressed = true;
			var type = 'play_hand';
			var success = playOrSkip ? 'success' : 'fail';
			// type = type + '_'+store.activeMatch.handNumber+'_'+store.activeMatch.currentHand.rollNumber;
			if(store.tutorialMode)
				type = 'tutorial_'+type;
			integration.postAnalyticsEvent(type, store.tutorialMode ? 'tutorial' : 'gameplay', store.activeMatch.handNumber);

			if(store.tutorialMode && store.activeMatch.handNumber === 1){
				 store.tutorialState = '';
			}
			if(store.tutorialMode && store.activeMatch.handNumber === 2){
				store.tutorialState = '';
				if(store.canUseExtraRoll)
					return;
			}

			// showScorecard();
			m.cup.returnCup();

			return;
		});
		if(shouldPulse)
			m.ui.makePulsate(button);
		else
			if(store.tutorialMode)
				m.skipTutorial.setAlpha(0);


		if(store.tutorialMode && store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 3) {
			button.alpha = 0.5;
		}

		m.scoreCardElements.push(button);

		//2nd button
		bx = (((960) / xMod * 3) - 10) - 240 * 2;
		bx = m.config.width / 2 + bx;
		// var button2;

		let rewardVideoLoaded = store.rewardAdIsLoaded;

		if(!store.activeMatch.currentHand.best && !store.oneTurnGame) {
			if(!store.canUseHandReset) {
				let buttonType = isEligibleForRewardRoll ? 'btn_watch.png' : store.canUseExtraRoll ? 'btn_extra_roll.png' : 'btn_extra_roll_gray.png';
				let buttonWidth = store.canUseExtraRoll ? (960)*0.425 : (960)*0.425;
				let buttonText = isEligibleForRewardRoll ? 'Watch' : m.ui.extraRollButtonText;

				if(buttonType === 'btn_extra_roll.png')
					integration.postAnalyticsEvent(`shown_extra_roll_option`, 'economy');
				else
					if(buttonType === 'btn_extra_roll_gray.png')
						integration.postAnalyticsEvent(`shown_extra_roll_greyed_out`, 'economy');

				m.ui.button2 = m.ui.createButton(buttonType, bx, m.adjustY(852) * yMod, buttonWidth, m.ui.defaultButtonHeight*1.25, buttonText, function (pointer) {
					if(m.ui.playHandButtonPressed === true || m.ui.extraRollButtonPressed === true) {
						console.log("play/skip already pressed");
						return;
					}

					if(isEligibleForRewardRoll && (!store.enableRewardAds || !rewardVideoLoaded))
						return;

					m.ui.extraRollButtonPressed = true;

					if(store.canUseExtraRoll) {
						comm.UseFreeRoll(store.activeMatch.matchId).then(() => {
							store.activeMatch.useHeart();
							if(store.tutorialMode)
								store.user.hearts += 1;

							integration.postAnalyticsEvent('spend_extra_roll', store.tutorialMode ? 'tutorial' : 'economy', store.activeMatch.handNumber);

							m.playAudio("BonusHeart");//_option4");
							m.updateHeartInfo();
							m.ui.animatePinkHeart(1);
							gameSetTimeout(m.ui.finishExtraRoll, 1500);
						}).catch(err => {
							console.log("comm.canUseFreeRoll err:"+err);
						});
					} else if(isEligibleForRewardRoll) {
						integration.postAnalyticsEvent(`spend_watch_ad_in_game`, 'economy');
						if(store.enableRewardAds && rewardVideoLoaded) {
							store.rewardAdModalHearts = -1;
							if(!(window.location.port === '3000' || window.location.hash === '#dev')) {
								if(store.rewardAdIsLoaded) {
									window.WrapperApp.postMessage("show-rewardVideo?name=default");
									gameSetTimeout(m.ui.dimPanelModal, 150);
								} else
									m.processRewardAdClosed();
							} else {
								m.processRewardAdClosed();
								m.ui.extraRollButtonPressed = false;
							}
						}
					} else {
						store.modal = 'heartszero';
						m.ui.extraRollButtonPressed = false;
					}
					return;
				});

				if(store.canUseExtraRoll) {
					m.ui.buttonPinkHeart = m.scene.add.sprite(-74*m.scaleFactor, -2*m.scaleFactor, 'common', 'pinkHeart.png');
					m.ui.buttonPinkHeart.setScale(m.oldAssetScaleFactor*0.9, m.oldAssetScaleFactor*1.1);
					m.ui.buttonPinkHeartText = m.scene.add.text(m.ui.buttonPinkHeart.x, m.ui.buttonPinkHeart.y, "1", { fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
					m.ui.buttonPinkHeartText.setOrigin(0.5,0.5);
					if(!store.canUseExtraRoll && !isEligibleForRewardRoll) {
						// pinkHeart.setAlpha(0.7);
						// heartText.setAlpha(0.7);
						m.ui.button2.setAlpha(0.5);
					}
					m.ui.button2.add(m.ui.buttonPinkHeart);
					m.ui.button2.add(m.ui.buttonPinkHeartText);
					m.ui.buttonPinkHeart.setAlpha(0);
					m.ui.buttonPinkHeartText.setAlpha(0);
				}
				m.scoreCardElements.push(m.ui.button2);

				if(isEligibleForRewardRoll && !store.tutorialMode) {
					var diceObjects = m.diceHand.dice;
					var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth * 1.25;
					yPos = m.adjustY(852)*yMod - 120 * m.scaleFactor;
					let watchVideoBanner = m.scene.add.image(m.config.width/2, yPos, 'language', 'popup_watch_video.png');
					watchVideoBanner.setScale(m.config.width / watchVideoBanner.width);
					watchVideoBanner.setDepth(6);
					m.scoreCardElements.push(watchVideoBanner);

					if(!rewardVideoLoaded)
						m.ui.button2.setAlpha(0.3);

					integration.postAnalyticsEvent(`shown_watch_ad_in_game`, 'economy', store.activeMatch.handNumber);
				}

			} else {
				let buttonType = 'btn_restart_hand.png';
				let buttonText = '     Restart Hand';

				integration.postAnalyticsEvent(`shown_restart_hand`, 'economy');

				m.ui.button2 = m.ui.createButton(buttonType, bx, m.adjustY(852) * yMod, (960)*0.425, m.ui.defaultButtonHeight*1.25, buttonText, function (pointer) {
					if(m.ui.playHandButtonPressed === true || m.ui.extraRollButtonPressed === true) {
						console.log("play/skip already pressed");
						return;
					}
					m.ui.extraRollButtonPressed = true;
					comm.UseHandReset(store.activeMatch.matchId).then(() => {
						store.activeMatch.useHandReset();
						integration.postAnalyticsEvent(`spend_hand_reset`, 'economy');
						m.playAudio("BonusHeart");//_option4");
						m.updateHeartInfo();
						m.ui.animatePinkHeart(5);
						gameSetTimeout(m.ui.finishHandReset, 1500);
					}).catch(err => {
						console.log("comm.canApplyHandReset err:"+err);
					});
				});
				m.ui.buttonPinkHeart = m.scene.add.sprite(-82*m.scaleFactor, -2*m.scaleFactor, 'common', 'pinkHeart.png');
				m.ui.buttonPinkHeart.setScale(m.oldAssetScaleFactor*0.9, m.oldAssetScaleFactor*1.1);
				m.ui.buttonPinkHeartText = m.scene.add.text(m.ui.buttonPinkHeart.x, m.ui.buttonPinkHeart.y, "5", { fontFamily: m.ui.dodFontFamily, fontSize: '56px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
				m.ui.buttonPinkHeartText.setOrigin(0.5,0.5);
				m.ui.buttonPinkHeartText.setAlpha(0);
				m.ui.buttonPinkHeart.setAlpha(0);
				m.ui.button2.add(m.ui.buttonPinkHeart);
				m.ui.button2.add(m.ui.buttonPinkHeartText);
				m.scoreCardElements.push(m.ui.button2);
			}

			if((store.canUseExtraRoll || (store.activeMatch.canUseHandReset && !store.canUseExtraRoll)) && store.user.hearts > 0){
				var evapTween = m.scene.tweens.add({
					targets		: [ m.ui.button2 ],
					scaleX		: m.ui.button2.scaleX * 1.2,
					scaleY		: m.ui.button2.scaleY * 1.2,
					ease			: 'Linear',
					delay			: 350,
					duration		: 350,
					yoyo			: true,
					repeat		: 0
				});
				m.scoreCardTweens.push(evapTween);
				var evapTween2 = m.scene.tweens.add({
					targets		: [ m.pinkHeart ],
					scaleX		: m.pinkHeart.scaleX * 1.2,
					scaleY		: m.pinkHeart.scaleY * 1.2,
					ease			: 'Linear',
					delay			: 350,
					duration		: 350,
					yoyo			: true,
					repeat		: 0
				});
				m.scoreCardTweens.push(evapTween2);
				var evapTween3 = m.scene.tweens.add({
					targets		: [ m.heartText ],
					scaleX		: m.heartText.scaleX * 1.2,
					scaleY		: m.heartText.scaleY* 1.2,
					ease			: 'Linear',
					delay			: 350,
					duration		: 350,
					yoyo			: true,
					repeat		: 0
				});
				m.scoreCardTweens.push(evapTween3);
			}
		}
	}
	dimPanelModal() {
		store.modal = 'videoDimPanel';
	}
	createNameplate(x, y, width, height, radius, color, alpha, dropShadow=0x0, depth=0, container=null) {
		var shadow = null;
		if(dropShadow > 0) {
			shadow = m.scene.add.graphics();
			shadow.lineStyle(1, dropShadow, alpha);
			shadow.fillStyle(dropShadow, alpha);
			shadow.fillRoundedRect(x, y+3, width, height, radius);
			if(depth > 0)
			shadow.setDepth(depth);
			if(container != null)
				container.add(shadow);
			m.scoreCardElements.push(shadow);
		}
		var graphics = m.scene.add.graphics();
		graphics.lineStyle(1, color, alpha);
		graphics.fillStyle(color, alpha);
		graphics.fillRoundedRect(x, y, width, height, radius);
		if(depth > 0)
			graphics.setDepth(depth);
		if(container != null)
			container.add(graphics);
		m.scoreCardElements.push(graphics);
		m.ui.lastPlate = graphics;
		return [graphics, shadow];
	}
}
